interface TranslationStrings {
  typeMessage: string;
  cancel: string;
  tapToSend: string;
  tapToStopRecording: string;
  // Video recording modal
  pause: string;
  pausing: string;
  stop: string;
  stopping: string;
  continue: string;
  resuming: string;
  switchCamera: string;
  switching: string;
  record: string;
  starting: string;
  send: string;
  sending: string;
  canceling: string;
  // Permission dialog
  mediaAccess: string;
  camera: string;
  microphone: string;
  granted: string;
  required: string;
  skipForNow: string;
  tryAgain: string;
  grantAccess: string;
  continueButton: string;
  // Media test dialog
  quickSetupCheck: string;
  testYour: string;
  cameraAndMicrophone: string;
  skip: string;
  preview: string;
  ensureWorkingProperly: string;
  linkCopied: string;
  copyThisLink: string;
  openInYourBrowser: string;
  showQuestion: string;
  question: string;
  mediaWarning: string;
  showMore: string;
  showLess: string;
  // Key error messages
  cameraAccessError: string;
  browserMediaSupport: string;
  enableMicrophoneAccess: string;
}

export interface Translations {
  [languageCode: string]: TranslationStrings;
}

export const translations: Translations = {
  af: {
    typeMessage: 'Tik boodskap',
    cancel: 'Kanselleer',
    tapToSend: 'Tik om te stuur',
    tapToStopRecording: 'Tik om opname te stop',
    // Video recording modal
    pause: 'Pouseer',
    pausing: 'Besig om te pouseer...',
    stop: 'Stop',
    stopping: 'Besig om te stop...',
    continue: 'Gaan voort',
    resuming: 'Besig om te hervat...',
    switchCamera: 'Wissel kamera',
    switching: 'Besig om te wissel...',
    record: 'Neem op',
    starting: 'Besig om te begin...',
    send: 'Stuur',
    sending: 'Besig om te stuur...',
    canceling: 'Besig om te kanselleer...',
    // Permission dialog
    mediaAccess: 'Media Toegang',
    camera: 'Kamera',
    microphone: 'Mikrofoon',
    granted: 'Toegestaan',
    required: 'Vereis',
    skipForNow: 'Slaan nou oor',
    tryAgain: 'Probeer weer',
    grantAccess: 'Verleen toegang',
    continueButton: 'Gaan voort',
    // Media test dialog
    quickSetupCheck: 'Vinnige opstellingstoets',
    testYour: 'Toets jou',
    cameraAndMicrophone: 'kamera en mikrofoon',
    skip: 'Slaan oor',
    preview: 'Voorskou',
    ensureWorkingProperly: 'om seker te maak alles werk behoorlik.',
    linkCopied: 'Skakel gekopieer!',
    copyThisLink: 'Kopieer hierdie skakel',
    openInYourBrowser: 'en open dit in jou standaardblaaier.',
    showQuestion: 'Wys vraag',
    question: 'Vraag',
    mediaWarning: 'Hierdie boodskap bevat media-lêers',
    showMore: 'Wys meer',
    showLess: 'Wys minder',
    // Key error messages
    cameraAccessError: "Laat asseblief kamera- en mikrofoontoegang toe om 'n video op te neem.",
    browserMediaSupport: 'Ongelukkig het jou blaaier nie media-opname-ondersteuning nie.',
    enableMicrophoneAccess:
      'Aktiveer mikrofoontoegang in jou blaaier-instellings om klankboodskappe te stuur.',
  },
  ar: {
    typeMessage: 'اكتب رسالة',
    cancel: 'إلغاء',
    tapToSend: 'اضغط للإرسال',
    tapToStopRecording: 'اضغط لإيقاف التسجيل',
    // Video recording modal
    pause: 'إيقاف مؤقت',
    pausing: 'جاري الإيقاف المؤقت...',
    stop: 'إيقاف',
    stopping: 'جاري الإيقاف...',
    continue: 'متابعة',
    resuming: 'جاري الاستئناف...',
    switchCamera: 'تبديل الكاميرا',
    switching: 'جاري التبديل...',
    record: 'تسجيل',
    starting: 'جاري البدء...',
    send: 'إرسال',
    sending: 'جاري الإرسال...',
    canceling: 'جاري الإلغاء...',
    // Permission dialog
    mediaAccess: 'الوصول إلى الوسائط',
    camera: 'الكاميرا',
    microphone: 'الميكروفون',
    granted: 'ممنوح',
    required: 'مطلوب',
    skipForNow: 'تخطي الآن',
    tryAgain: 'حاول مرة أخرى',
    grantAccess: 'منح الصلاحية',
    continueButton: 'متابعة',
    // Media test dialog
    quickSetupCheck: 'فحص الإعداد السريع',
    testYour: 'اختبر',
    cameraAndMicrophone: 'الكاميرا والميكروفون',
    skip: 'تخطي',
    preview: 'معاينة',
    ensureWorkingProperly: 'للتأكد من أن كل شيء يعمل بشكل صحيح.',
    linkCopied: 'تم نسخ الرابط!',
    copyThisLink: 'نسخ هذا الرابط',
    openInYourBrowser: 'وفتحه في متصفحك الافتراضي.',
    showQuestion: 'عرض السؤال',
    question: 'السؤال',
    mediaWarning: 'تحتوي هذه الرسالة على ملفات وسائط',
    showMore: 'عرض المزيد',
    showLess: 'عرض أقل',
    // Key error messages
    cameraAccessError: 'يرجى السماح بالوصول إلى الكاميرا والميكروفون لتسجيل فيديو.',
    browserMediaSupport: 'للأسف، متصفحك لا يدعم تسجيل الوسائط.',
    enableMicrophoneAccess:
      'قم بتمكين الوصول إلى الميكروفون في إعدادات المتصفح لإرسال رسائل صوتية.',
  },
  hy: {
    typeMessage: 'Մուտքագրեք հաղորդագրություն',
    cancel: 'Չեղարկել',
    tapToSend: 'Հպեք ուղարկելու համար',
    tapToStopRecording: 'Հպեք՝ ձայնագրումը դադարեցնելու համար',
    // Video recording modal
    pause: 'Դադարեցնել',
    pausing: 'Դադարեցվում է...',
    stop: 'Դադարեցնել',
    stopping: 'Դադարեցվում է...',
    continue: 'Շարունակել',
    resuming: 'Շարունակվում է...',
    switchCamera: 'Փոխել տեսախցիկը',
    switching: 'Փոխվում է...',
    record: 'Գրանցել',
    starting: 'Սկսվում է...',
    send: 'Ուղարկել',
    sending: 'Ուղարկվում է...',
    canceling: 'Չեղարկվում է...',
    // Permission dialog
    mediaAccess: 'Մեդիա մուտք',
    camera: 'Կամերա',
    microphone: 'Խոսափող',
    granted: 'Տրված',
    required: 'Պահանջվում է',
    skipForNow: 'Այս պահին բաց թողնել',
    tryAgain: 'Փորձել նորից',
    grantAccess: 'Թույլ տալ մուտք',
    continueButton: 'Շարունակել',
    // Media test dialog
    quickSetupCheck: 'Արագ տեղադրման ստուգում',
    testYour: 'Փորձարկեք ձեր',
    cameraAndMicrophone: 'տեսախցիկը և խոսափողը',
    skip: 'Բաց թողնել',
    preview: 'Նախադիտում',
    ensureWorkingProperly: 'համոզվելու համար, որ ամեն ինչ աշխատում է ճիշտ:',
    linkCopied: 'Հղումը պատճենվել է!',
    copyThisLink: 'Պատճենել այս հղումը',
    openInYourBrowser: 'և բացել ձեր նախընտրած դիտարկչում:',
    showQuestion: 'Ցույց տալ հարցը',
    question: 'Հարց',
    mediaWarning: 'Այս հաղորդագրությունը պարունակում է մեդիա ֆայլեր',
    showMore: 'Ցույց տալ ավելին',
    showLess: 'Ցույց տալ պակաս',
    // Key error messages
    cameraAccessError:
      'Խնդրում ենք թույլատրել տեսախցիկի և խոսափողի մուտքը տեսանյութ ձայնագրելու համար:',
    browserMediaSupport: 'Ցավոք, ձեր դիտարկիչը չի աջակցում մեդիա ձայնագրման:',
    enableMicrophoneAccess:
      'Միացրեք խոսափողի մուտքը ձեր դիտարկիչի կարգավորումներում՝ ձայնային հաղորդագրություններ ուղարկելու համար:',
  },
  az: {
    typeMessage: 'Mesaj yazın',
    cancel: 'Ləğv et',
    tapToSend: 'Göndərmək üçün toxunun',
    tapToStopRecording: 'Yazını dayandırmaq üçün toxunun',
    // Video recording modal
    pause: 'Dayandır',
    pausing: 'Dayandırılır...',
    stop: 'Dayan',
    stopping: 'Dayandırılır...',
    continue: 'Davam et',
    resuming: 'Davam edilir...',
    switchCamera: 'Kameranı dəyiş',
    switching: 'Dəyişdirilir...',
    record: 'Yazıya al',
    starting: 'Başladılır...',
    send: 'Göndər',
    sending: 'Göndərilir...',
    canceling: 'Ləğv edilir...',
    // Permission dialog
    mediaAccess: 'Media Girişi',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Verildi',
    required: 'Tələb olunur',
    skipForNow: 'İndi keç',
    tryAgain: 'Yenidən cəhd et',
    grantAccess: 'Giriş ver',
    continueButton: 'Davam et',
    // Media test dialog
    quickSetupCheck: 'Sürətli quraşdırma yoxlaması',
    testYour: 'Test edin',
    cameraAndMicrophone: 'kamera və mikrofonu',
    skip: 'Keç',
    preview: 'Önizləmə',
    ensureWorkingProperly: 'hər şeyin düzgün işlədiyinə əmin olmaq üçün.',
    linkCopied: 'Link kopyalandı!',
    copyThisLink: 'Bu linki kopyalayın',
    openInYourBrowser: 'və standart brauzerinizdə açın.',
    showQuestion: 'Sualı göstər',
    question: 'Sual',
    mediaWarning: 'Bu mesaj media faylları ehtiva edir',
    showMore: 'Daha çox göstər',
    showLess: 'Daha az göstər',
    // Key error messages
    cameraAccessError: 'Video çəkmək üçün zəhmət olmasa kamera və mikrofon girişinə icazə verin.',
    browserMediaSupport: 'Təəssüf ki, brauzeriniz media yazma dəstəyi yoxdur.',
    enableMicrophoneAccess:
      'Səsli mesaj göndərmək üçün brauzer parametrlərində mikrofon girişini aktivləşdirin.',
  },
  be: {
    typeMessage: 'Увядзіце паведамленне',
    cancel: 'Адмяніць',
    tapToSend: 'Дакраніцеся, каб адправіць',
    tapToStopRecording: 'Дакраніцеся, каб спыніць запіс',
    // Video recording modal
    pause: 'Паўза',
    pausing: 'Паўза...',
    stop: 'Спыніць',
    stopping: 'Спыненне...',
    continue: 'Працягнуць',
    resuming: 'Аднаўленне...',
    switchCamera: 'Пераключыць камеру',
    switching: 'Пераключэнне...',
    record: 'Запіс',
    starting: 'Запуск...',
    send: 'Адправіць',
    sending: 'Адпраўка...',
    canceling: 'Скасаванне...',
    // Permission dialog
    mediaAccess: 'Доступ да медыя',
    camera: 'Камера',
    microphone: 'Мікрафон',
    granted: 'Дазволена',
    required: 'Патрэбна',
    skipForNow: 'Прапусціць зараз',
    tryAgain: 'Спрабаваць зноў',
    grantAccess: 'Дазволіць доступ',
    continueButton: 'Працягнуць',
    // Media test dialog
    quickSetupCheck: 'Хуткая праверка налад',
    testYour: 'Праверце вашу',
    cameraAndMicrophone: 'камеру і мікрафон',
    skip: 'Прапусціць',
    preview: 'Папярэдні прагляд',
    ensureWorkingProperly: 'каб пераканацца, што ўсё працуе належным чынам.',
    linkCopied: 'Спасылка скапіявана!',
    copyThisLink: 'Скапіраваць гэтую спасылку',
    openInYourBrowser: 'і адчыніць у вашым браўзеры.',
    showQuestion: 'Паказаць пытанне',
    question: 'Пытанне',
    mediaWarning: 'Гэта паведамленне змяшчае медыяфайлы',
    showMore: 'Паказаць больш',
    showLess: 'Паказаць менш',
    // Key error messages
    cameraAccessError: 'Калі ласка, дазвольце доступ да камеры і мікрафона для запісу відэа.',
    browserMediaSupport: 'На жаль, ваш браўзер не падтрымлівае запіс медыя.',
    enableMicrophoneAccess:
      'Уключыце доступ да мікрафона ў наладах браўзера, каб адпраўляць галасавыя паведамленні.',
  },
  bs: {
    typeMessage: 'Ukucajte poruku',
    cancel: 'Otkaži',
    tapToSend: 'Dodirnite za slanje',
    tapToStopRecording: 'Dodirnite za zaustavljanje snimanja',
    // Video recording modal
    pause: 'Pauza',
    pausing: 'Pauziranje...',
    stop: 'Zaustaviti',
    stopping: 'Zaustavljanje...',
    continue: 'Nastaviti',
    resuming: 'Nastavljanje...',
    switchCamera: 'Promijeniti kameru',
    switching: 'Mijenjanje...',
    record: 'Snimiti',
    starting: 'Pokretanje...',
    send: 'Poslati',
    sending: 'Slanje...',
    canceling: 'Otkazivanje...',
    // Permission dialog
    mediaAccess: 'Pristup medijima',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Odobreno',
    required: 'Potrebno',
    skipForNow: 'Preskočiti za sada',
    tryAgain: 'Pokušati ponovo',
    grantAccess: 'Odobriti pristup',
    continueButton: 'Nastaviti',
    // Media test dialog
    quickSetupCheck: 'Brza provjera postavki',
    testYour: 'Testiraj svoj',
    cameraAndMicrophone: 'kameru i mikrofon',
    skip: 'Preskoči',
    preview: 'Pregled',
    ensureWorkingProperly: 'da biste bili sigurni da sve radi ispravno.',
    linkCopied: 'Link kopiran!',
    copyThisLink: 'Kopiraj ovu vezu',
    openInYourBrowser: 'i otvorite u svom pregledniku.',
    showQuestion: 'Prikaži pitanje',
    question: 'Pitanje',
    mediaWarning: 'Ova poruka sadrži medijske datoteke',
    showMore: 'Prikaži više',
    showLess: 'Prikaži manje',
    // Key error messages
    cameraAccessError: 'Molimo dozvolite pristup kameri i mikrofonu za snimanje videa.',
    browserMediaSupport: 'Nažalost, vaš preglednik nema podršku za snimanje medija.',
    enableMicrophoneAccess:
      'Omogućite pristup mikrofonu u postavkama preglednika za slanje audio poruka.',
  },
  bg: {
    typeMessage: 'Напишете съобщение',
    cancel: 'Отказ',
    tapToSend: 'Докоснете за изпращане',
    tapToStopRecording: 'Докоснете за спиране на записа',
    // Video recording modal
    pause: 'Пауза',
    pausing: 'Поставяне на пауза...',
    stop: 'Спиране',
    stopping: 'Спиране...',
    continue: 'Продължаване',
    resuming: 'Възобновяване...',
    switchCamera: 'Превключване на камера',
    switching: 'Превключване...',
    record: 'Запис',
    starting: 'Започване...',
    send: 'Изпращане',
    sending: 'Изпращане...',
    canceling: 'Отмяна...',
    // Permission dialog
    mediaAccess: 'Достъп до медии',
    camera: 'Камера',
    microphone: 'Микрофон',
    granted: 'Разрешено',
    required: 'Необходимо',
    skipForNow: 'Пропуснете засега',
    tryAgain: 'Опитайте отново',
    grantAccess: 'Разрешете достъп',
    continueButton: 'Продължете',
    // Media test dialog
    quickSetupCheck: 'Бърза проверка на настройките',
    testYour: 'Тествайте вашата',
    cameraAndMicrophone: 'камера и микрофон',
    skip: 'Пропуснете',
    preview: 'Преглед',
    ensureWorkingProperly: 'за да се уверите, че всичко работи правилно.',
    linkCopied: 'Връзката е копирана!',
    copyThisLink: 'Копирайте тази връзка',
    openInYourBrowser: 'и я отворете в браузъра си.',
    showQuestion: 'Покажи въпроса',
    question: 'Въпрос',
    mediaWarning: 'Това съобщение съдържа медийни файлове',
    showMore: 'Покажи повече',
    showLess: 'Покажи по-малко',
    // Key error messages
    cameraAccessError: 'Моля, разрешете достъпа до камерата и микрофона, за да запишете видео.',
    browserMediaSupport: 'За съжаление, вашият браузър не поддържа запис на медия.',
    enableMicrophoneAccess:
      'Активирайте достъпа до микрофона в настройките на браузъра, за да изпращате аудио съобщения.',
  },
  yue: {
    typeMessage: '輸入訊息...',
    cancel: '取消',
    tapToSend: '撳嚟發送',
    tapToStopRecording: '撳嚟停止錄音',
    pause: '暫停',
    pausing: '暫停緊...',
    stop: '停止',
    stopping: '停止緊...',
    continue: '繼續',
    resuming: '繼續緊...',
    switchCamera: '轉換鏡頭',
    switching: '轉換緊...',
    record: '錄音',
    starting: '開始緊...',
    send: '發送',
    sending: '發送緊...',
    canceling: '取消緊...',
    mediaAccess: '媒體存取',
    camera: '鏡頭',
    microphone: '麥克風',
    granted: '已授權',
    required: '需要',
    skipForNow: '暫時跳過',
    tryAgain: '重試',
    grantAccess: '授予存取權限',
    continueButton: '繼續',
    quickSetupCheck: '快速設定檢查',
    testYour: '測試你嘅',
    cameraAndMicrophone: '鏡頭同麥克風',
    skip: '跳過',
    preview: '預覽',
    ensureWorkingProperly: '確保正常運作',
    linkCopied: '連結已複製',
    copyThisLink: '複製呢個連結',
    openInYourBrowser: '喺你嘅瀏覽器開啟',
    cameraAccessError: '鏡頭存取錯誤',
    browserMediaSupport: '瀏覽器媒體支援',
    enableMicrophoneAccess: '啟用麥克風存取',
  },
  zh: {
    typeMessage: '输入消息',
    cancel: '取消',
    tapToSend: '点击发送',
    tapToStopRecording: '点击停止录音',
    // Video recording modal
    pause: '暂停',
    pausing: '正在暂停...',
    stop: '停止',
    stopping: '正在停止...',
    continue: '继续',
    resuming: '正在恢复...',
    switchCamera: '切换摄像头',
    switching: '正在切换...',
    record: '录制',
    starting: '正在开始...',
    send: '发送',
    sending: '正在发送...',
    canceling: '正在取消...',
    // Permission dialog
    mediaAccess: '媒体访问',
    camera: '摄像头',
    microphone: '麦克风',
    granted: '已授权',
    required: '需要',
    skipForNow: '暂时跳过',
    tryAgain: '重试',
    grantAccess: '授予权限',
    continueButton: '继续',
    // Media test dialog
    quickSetupCheck: '快速设置检查',
    testYour: '测试您的',
    cameraAndMicrophone: '摄像头和麦克风',
    skip: '跳过',
    preview: '预览',
    ensureWorkingProperly: '以确保一切正常工作。',
    linkCopied: '链接已复制！',
    copyThisLink: '复制此链接',
    openInYourBrowser: '并在您的浏览器中打开。',
    showQuestion: '显示问题',
    question: '问题',
    mediaWarning: '此消息包含媒体文件',
    showMore: '显示更多',
    showLess: '显示更少',
    // Key error messages
    cameraAccessError: '请允许访问摄像头和麦克风以录制视频。',
    browserMediaSupport: '很遗憾，您的浏览器不支持媒体录制。',
    enableMicrophoneAccess: '在浏览器设置中启用麦克风访问权限以发送音频消息。',
  },
  ca: {
    typeMessage: 'Escriu missatge',
    cancel: 'Cancel·lar',
    tapToSend: 'Toca per enviar',
    tapToStopRecording: 'Toca per aturar la gravació',
    // Video recording modal
    pause: 'Pausa',
    pausing: 'Pausant...',
    stop: 'Atura',
    stopping: 'Aturant...',
    continue: 'Continua',
    resuming: 'Reprenent...',
    switchCamera: 'Canvia la càmera',
    switching: 'Canviant...',
    record: 'Grava',
    starting: 'Iniciant...',
    send: 'Envia',
    sending: 'Enviant...',
    canceling: 'Cancel·lant...',
    // Permission dialog
    mediaAccess: 'Accés als mitjans',
    camera: 'Càmera',
    microphone: 'Micròfon',
    granted: 'Concedit',
    required: 'Requerit',
    skipForNow: 'Omet ara',
    tryAgain: 'Prova de nou',
    grantAccess: 'Concedir accés',
    continueButton: 'Continua',
    // Media test dialog
    quickSetupCheck: 'Comprovació ràpida de configuració',
    testYour: 'Prova la teva',
    cameraAndMicrophone: 'càmera i micròfon',
    skip: 'Omet',
    preview: 'Vista prèvia',
    ensureWorkingProperly: 'per assegurar-te que tot funciona correctament.',
    linkCopied: 'Enllaç copiat!',
    copyThisLink: 'Copia aquest enllaç',
    openInYourBrowser: "i obre'l al teu navegador predeterminat.",
    showQuestion: 'Mostra la pregunta',
    question: 'Pregunta',
    mediaWarning: 'Aquest missatge conté fitxers multimèdia',
    showMore: 'Mostra més',
    showLess: 'Mostra menys',
    // Key error messages
    cameraAccessError: "Si us plau, permet l'accés a la càmera i al micròfon per gravar un vídeo.",
    browserMediaSupport: 'Malauradament, el teu navegador no admet la gravació de mitjans.',
    enableMicrophoneAccess:
      "Activa l'accés al micròfon a la configuració del navegador per enviar missatges d'àudio.",
  },
  zh: {
    typeMessage: '输入信息',
    cancel: '取消',
    tapToSend: '点击发送',
    tapToStopRecording: '点击停止录音',
    // Video recording modal
    pause: '暂停',
    pausing: '正在暂停...',
    stop: '停止',
    stopping: '正在停止...',
    continue: '继续',
    resuming: '正在恢复...',
    switchCamera: '切换摄像头',
    switching: '正在切换...',
    record: '录制',
    starting: '正在开始...',
    send: '发送',
    sending: '正在发送...',
    canceling: '正在取消...',
    // Permission dialog
    mediaAccess: '媒体访问',
    camera: '摄像头',
    microphone: '麦克风',
    granted: '已授权',
    required: '需要',
    skipForNow: '暂时跳过',
    tryAgain: '重试',
    grantAccess: '授予权限',
    continueButton: '继续',
    // Media test dialog
    quickSetupCheck: '快速设置检查',
    testYour: '测试您的',
    cameraAndMicrophone: '摄像头和麦克风',
    skip: '跳过',
    preview: '预览',
    ensureWorkingProperly: '以确保一切正常工作。',
    linkCopied: '链接已复制！',
    copyThisLink: '复制此链接',
    openInYourBrowser: '并在您的浏览器中打开。',
    showQuestion: '显示问题',
    question: '问题',
    mediaWarning: '此消息包含媒体文件',
    showMore: '显示更多',
    showLess: '显示更少',
    // Key error messages
    cameraAccessError: '请允许访问摄像头和麦克风以录制视频。',
    browserMediaSupport: '很遗憾，您的浏览器不支持媒体录制。',
    enableMicrophoneAccess: '在浏览器设置中启用麦克风访问权限以发送音频消息。',
  },
  hr: {
    typeMessage: 'Upišite poruku',
    cancel: 'Otkaži',
    tapToSend: 'Dodirnite za slanje',
    tapToStopRecording: 'Dodirnite za zaustavljanje snimanja',
    // Video recording modal
    pause: 'Pauza',
    pausing: 'Pauziranje...',
    stop: 'Zaustaviti',
    stopping: 'Zaustavljanje...',
    continue: 'Nastaviti',
    resuming: 'Nastavljanje...',
    switchCamera: 'Promijeniti kameru',
    switching: 'Mijenjanje...',
    record: 'Snimiti',
    starting: 'Pokretanje...',
    send: 'Poslati',
    sending: 'Slanje...',
    canceling: 'Otkazivanje...',
    // Permission dialog
    mediaAccess: 'Pristup medijima',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Odobreno',
    required: 'Potrebno',
    skipForNow: 'Preskočiti za sada',
    tryAgain: 'Pokušati ponovo',
    grantAccess: 'Odobriti pristup',
    continueButton: 'Nastaviti',
    // Media test dialog
    quickSetupCheck: 'Brza provjera postavki',
    testYour: 'Testirajte vašu',
    cameraAndMicrophone: 'kameru i mikrofon',
    skip: 'Preskoči',
    preview: 'Pregled',
    ensureWorkingProperly: 'da biste bili sigurni da sve radi ispravno.',
    linkCopied: 'Link kopiran!',
    copyThisLink: 'Kopiraj ovu vezu',
    openInYourBrowser: 'i otvorite u svom pregledniku.',
    showQuestion: 'Prikaži pitanje',
    question: 'Pitanje',
    mediaWarning: 'Ova poruka sadrži medijske datoteke',
    showMore: 'Prikaži više',
    showLess: 'Prikaži manje',
    // Key error messages
    cameraAccessError: 'Molimo dozvolite pristup kameri i mikrofonu za snimanje videozapisa.',
    browserMediaSupport: 'Nažalost, vaš preglednik ne podržava snimanje medija.',
    enableMicrophoneAccess:
      'Omogućite pristup mikrofonu u postavkama preglednika za slanje audio poruka.',
  },
  cs: {
    typeMessage: 'Napište zprávu',
    cancel: 'Zrušit',
    tapToSend: 'Klepněte pro odeslání',
    tapToStopRecording: 'Klepnutím zastavíte nahrávání',
    // Video recording modal
    pause: 'Pauza',
    pausing: 'Pozastavování...',
    stop: 'Zastavit',
    stopping: 'Zastavování...',
    continue: 'Pokračovat',
    resuming: 'Obnovování...',
    switchCamera: 'Přepnout kameru',
    switching: 'Přepínání...',
    record: 'Nahrávat',
    starting: 'Spouštění...',
    send: 'Odeslat',
    sending: 'Odesílání...',
    canceling: 'Rušení...',
    // Permission dialog
    mediaAccess: 'Přístup k médiím',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Povoleno',
    required: 'Požadováno',
    skipForNow: 'Prozatím přeskočit',
    tryAgain: 'Zkusit znovu',
    grantAccess: 'Povolit přístup',
    continueButton: 'Pokračovat',
    // Media test dialog
    quickSetupCheck: 'Rychlá kontrola nastavení',
    testYour: 'Otestujte svou',
    cameraAndMicrophone: 'kameru a mikrofon',
    skip: 'Přeskočit',
    preview: 'Náhled',
    ensureWorkingProperly: 'pro zajištění správné funkčnosti.',
    linkCopied: 'Odkaz zkopírován!',
    copyThisLink: 'Zkopírujte tento odkaz',
    openInYourBrowser: 'a otevřete ve svém prohlížeči.',
    showQuestion: 'Zobrazit otázku',
    question: 'Otázka',
    mediaWarning: 'Tato zpráva obsahuje mediální soubory',
    showMore: 'Zobrazit více',
    showLess: 'Zobrazit méně',
    // Key error messages
    cameraAccessError: 'Prosím povolte přístup ke kameře a mikrofonu pro nahrání videa.',
    browserMediaSupport: 'Bohužel váš prohlížeč nepodporuje nahrávání médií.',
    enableMicrophoneAccess:
      'Povolte přístup k mikrofonu v nastavení prohlížeče pro odesílání zvukových zpráv.',
  },
  da: {
    typeMessage: 'Skriv besked',
    cancel: 'Annuller',
    tapToSend: 'Tryk for at sende',
    tapToStopRecording: 'Tryk for at stoppe optagelse',
    // Video recording modal
    pause: 'Pause',
    pausing: 'Pauser...',
    stop: 'Stop',
    stopping: 'Stopper...',
    continue: 'Fortsæt',
    resuming: 'Genoptager...',
    switchCamera: 'Skift kamera',
    switching: 'Skifter...',
    record: 'Optag',
    starting: 'Starter...',
    send: 'Send',
    sending: 'Sender...',
    canceling: 'Annullerer...',
    // Permission dialog
    mediaAccess: 'Medieadgang',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Givet',
    required: 'Påkrævet',
    skipForNow: 'Spring over nu',
    tryAgain: 'Prøv igen',
    grantAccess: 'Giv adgang',
    continueButton: 'Fortsæt',
    // Media test dialog
    quickSetupCheck: 'Hurtig opsætningskontrol',
    testYour: 'Test dit',
    cameraAndMicrophone: 'kamera og mikrofon',
    skip: 'Spring over',
    preview: 'Forhåndsvisning',
    ensureWorkingProperly: 'for at sikre, at alt fungerer korrekt.',
    linkCopied: 'Link kopieret!',
    copyThisLink: 'Kopier dette link',
    openInYourBrowser: 'og åbn det i din standardbrowser.',
    showQuestion: 'Vis spørgsmål',
    question: 'Spørgsmål',
    mediaWarning: 'Denne besked indeholder mediefiler',
    showMore: 'Vis mere',
    showLess: 'Vis mindre',
    // Key error messages
    cameraAccessError: 'Tillad venligst adgang til kamera og mikrofon for at optage en video.',
    browserMediaSupport: 'Desværre understøtter din browser ikke medieoptagelse.',
    enableMicrophoneAccess:
      'Aktivér mikrofonadgang i dine browserindstillinger for at sende lydmeddelelser.',
  },
  nl: {
    typeMessage: 'Typ bericht',
    cancel: 'Annuleren',
    tapToSend: 'Tik om te verzenden',
    tapToStopRecording: 'Tik om opname te stoppen',
    // Video recording modal
    pause: 'Pauzeren',
    pausing: 'Pauzeren...',
    stop: 'Stoppen',
    stopping: 'Stoppen...',
    continue: 'Doorgaan',
    resuming: 'Hervatten...',
    switchCamera: 'Camera wisselen',
    switching: 'Wisselen...',
    record: 'Opnemen',
    starting: 'Starten...',
    send: 'Verzenden',
    sending: 'Verzenden...',
    canceling: 'Annuleren...',
    // Permission dialog
    mediaAccess: 'Mediatoegang',
    camera: 'Camera',
    microphone: 'Microfoon',
    granted: 'Toegestaan',
    required: 'Vereist',
    skipForNow: 'Nu overslaan',
    tryAgain: 'Opnieuw proberen',
    grantAccess: 'Toegang verlenen',
    continueButton: 'Doorgaan',
    // Media test dialog
    quickSetupCheck: 'Snelle installatiecontrole',
    testYour: 'Test je',
    cameraAndMicrophone: 'camera en microfoon',
    skip: 'Overslaan',
    preview: 'Voorbeeld',
    ensureWorkingProperly: 'om ervoor te zorgen dat alles correct werkt.',
    linkCopied: 'Link gekopieerd!',
    copyThisLink: 'Kopieer deze link',
    openInYourBrowser: 'en open deze in je standaardbrowser.',
    showQuestion: 'Toon vraag',
    question: 'Vraag',
    mediaWarning: 'Dit bericht bevat mediabestanden',
    showMore: 'Toon meer',
    showLess: 'Toon minder',
    // Key error messages
    cameraAccessError: 'Sta toegang tot camera en microfoon toe om een video op te nemen.',
    browserMediaSupport: 'Helaas ondersteunt je browser geen media-opname.',
    enableMicrophoneAccess:
      'Schakel microfoontoegang in je browserinstellingen in om audioberichten te verzenden.',
  },
  en: {
    typeMessage: 'Type message',
    cancel: 'Cancel',
    tapToSend: 'Tap to send',
    tapToStopRecording: 'Tap to stop recording',
    // Video recording modal
    pause: 'Pause',
    pausing: 'Pausing...',
    stop: 'Stop',
    stopping: 'Stopping...',
    continue: 'Continue',
    resuming: 'Resuming...',
    switchCamera: 'Switch camera',
    switching: 'Switching...',
    record: 'Record',
    starting: 'Starting...',
    send: 'Send',
    sending: 'Sending...',
    canceling: 'Canceling...',
    // Permission dialog
    mediaAccess: 'Media Access',
    camera: 'Camera',
    microphone: 'Microphone',
    granted: 'Granted',
    required: 'Required',
    skipForNow: 'Skip for now',
    tryAgain: 'Try again',
    grantAccess: 'Grant access',
    continueButton: 'Continue',
    // Media test dialog
    quickSetupCheck: 'Quick setup check',
    testYour: 'Test your',
    cameraAndMicrophone: 'camera and microphone',
    skip: 'Skip',
    preview: 'Preview',
    ensureWorkingProperly: 'to ensure everything is working properly.',
    linkCopied: 'Link copied!',
    copyThisLink: 'Copy this link',
    openInYourBrowser: 'and open in your default browser.',
    showQuestion: 'Show question',
    question: 'Question',
    mediaWarning: 'This message contains media files',
    showMore: 'Show more',
    showLess: 'Show less',
    // Key error messages
    cameraAccessError: 'Please allow camera and microphone access to record a video.',
    browserMediaSupport: 'Unfortunately, your browser lacks media recording support.',
    enableMicrophoneAccess:
      'Enable microphone access in your browser settings to send audio messages.',
  },
  et: {
    typeMessage: 'Kirjuta sõnum',
    cancel: 'Tühista',
    tapToSend: 'Puudutage saatmiseks',
    tapToStopRecording: 'Puudutage salvestamise peatamiseks',
    // Video recording modal
    pause: 'Paus',
    pausing: 'Peatamine...',
    stop: 'Lõpeta',
    stopping: 'Lõpetamine...',
    continue: 'Jätka',
    resuming: 'Jätkamine...',
    switchCamera: 'Vaheta kaamerat',
    switching: 'Vahetamine...',
    record: 'Salvesta',
    starting: 'Alustamine...',
    send: 'Saada',
    sending: 'Saatmine...',
    canceling: 'Tühistamine...',
    // Permission dialog
    mediaAccess: 'Meedia juurdepääs',
    camera: 'Kaamera',
    microphone: 'Mikrofon',
    granted: 'Antud',
    required: 'Nõutav',
    skipForNow: 'Jäta praegu vahele',
    tryAgain: 'Proovi uuesti',
    grantAccess: 'Anna juurdepääs',
    continueButton: 'Jätka',
    // Media test dialog
    quickSetupCheck: 'Kiire seadistuse kontroll',
    testYour: 'Testi oma',
    cameraAndMicrophone: 'kaamerat ja mikrofoni',
    skip: 'Jäta vahele',
    preview: 'Eelvaade',
    ensureWorkingProperly: 'et veenduda, et kõik töötab korralikult.',
    linkCopied: 'Link on kopeeritud!',
    copyThisLink: 'Kopeeri see link',
    openInYourBrowser: 'ja ava see oma brauseris.',
    showQuestion: 'Näita küsimust',
    question: 'Küsimus',
    mediaWarning: 'See sõnum sisaldab meediafaile',
    showMore: 'Näita rohkem',
    showLess: 'Näita vähem',
    // Key error messages
    cameraAccessError: 'Palun lubage kaamera ja mikrofoni juurdepääs video salvestamiseks.',
    browserMediaSupport: 'Kahjuks ei toeta teie brauser meedia salvestamist.',
    enableMicrophoneAccess: 'Lubage mikrofoni juurdepääs brauseri seadetes heliteadete saatmiseks.',
  },
  fi: {
    typeMessage: 'Kirjoita viesti',
    cancel: 'Peruuta',
    tapToSend: 'Lähetä napauttamalla',
    tapToStopRecording: 'Lopeta tallennus napauttamalla',
    // Video recording modal
    pause: 'Keskeytä',
    pausing: 'Keskeytetään...',
    stop: 'Lopeta',
    stopping: 'Lopetetaan...',
    continue: 'Jatka',
    resuming: 'Jatketaan...',
    switchCamera: 'Vaihda kameraa',
    switching: 'Vaihdetaan...',
    record: 'Tallenna',
    starting: 'Aloitetaan...',
    send: 'Lähetä',
    sending: 'Lähetetään...',
    canceling: 'Peruutetaan...',
    // Permission dialog
    mediaAccess: 'Mediakäyttöoikeus',
    camera: 'Kamera',
    microphone: 'Mikrofoni',
    granted: 'Myönnetty',
    required: 'Vaaditaan',
    skipForNow: 'Ohita toistaiseksi',
    tryAgain: 'Yritä uudelleen',
    grantAccess: 'Myönnä käyttöoikeus',
    continueButton: 'Jatka',
    // Media test dialog
    quickSetupCheck: 'Nopea asetusten tarkistus',
    testYour: 'Testaa',
    cameraAndMicrophone: 'kamera ja mikrofoni',
    skip: 'Ohita',
    preview: 'Esikatselu',
    ensureWorkingProperly: 'varmistaaksesi, että kaikki toimii oikein.',
    linkCopied: 'Linkki kopioitu!',
    copyThisLink: 'Kopioi tämä linkki',
    openInYourBrowser: 'ja avaa se omassa selaimessasi.',
    showQuestion: 'Näytä kysymys',
    question: 'Kysymys',
    mediaWarning: 'Tämä viesti sisältää mediatiedostoja',
    showMore: 'Näytä enemmän',
    showLess: 'Näytä vähemmän',
    // Key error messages
    cameraAccessError: 'Salli kameran ja mikrofonin käyttö videon tallentamiseksi.',
    browserMediaSupport: 'Valitettavasti selaimesi ei tue median tallennusta.',
    enableMicrophoneAccess:
      'Ota mikrofonin käyttö käyttöön selaimen asetuksissa ääniviestien lähettämiseksi.',
  },
  fr: {
    typeMessage: 'Tapez un message',
    cancel: 'Annuler',
    tapToSend: 'Appuyez pour envoyer',
    tapToStopRecording: "Appuyez pour arrêter l'enregistrement",
    // Video recording modal
    pause: 'Pause',
    pausing: 'Mise en pause...',
    stop: 'Arrêter',
    stopping: 'Arrêt en cours...',
    continue: 'Continuer',
    resuming: 'Reprise...',
    switchCamera: 'Changer de caméra',
    switching: 'Changement...',
    record: 'Enregistrer',
    starting: 'Démarrage...',
    send: 'Envoyer',
    sending: 'Envoi...',
    canceling: 'Annulation...',
    // Permission dialog
    mediaAccess: 'Accès aux médias',
    camera: 'Caméra',
    microphone: 'Microphone',
    granted: 'Accordé',
    required: 'Requis',
    skipForNow: 'Ignorer pour le moment',
    tryAgain: 'Réessayer',
    grantAccess: "Accorder l'accès",
    continueButton: 'Continuer',
    // Media test dialog
    quickSetupCheck: 'Vérification rapide de la configuration',
    testYour: 'Testez votre',
    cameraAndMicrophone: 'caméra et microphone',
    skip: 'Passer',
    preview: 'Aperçu',
    ensureWorkingProperly: 'pour vous assurer que tout fonctionne correctement.',
    linkCopied: 'Lien copié !',
    copyThisLink: 'Copiez ce lien',
    openInYourBrowser: 'et ouvrez-le dans votre navigateur.',
    showQuestion: 'Afficher la question',
    question: 'Question',
    mediaWarning: 'Ce message contient des fichiers multimédias',
    showMore: 'Afficher plus',
    showLess: 'Afficher moins',
    // Key error messages
    cameraAccessError:
      "Veuillez autoriser l'accès à la caméra et au microphone pour enregistrer une vidéo.",
    browserMediaSupport:
      "Malheureusement, votre navigateur ne prend pas en charge l'enregistrement média.",
    enableMicrophoneAccess:
      "Activez l'accès au microphone dans les paramètres de votre navigateur pour envoyer des messages audio.",
  },
  gl: {
    typeMessage: 'Escribir mensaxe',
    cancel: 'Cancelar',
    tapToSend: 'Toca para enviar',
    tapToStopRecording: 'Toca para deter a gravación',
    // Video recording modal
    pause: 'Pausar',
    pausing: 'Pausando...',
    stop: 'Parar',
    stopping: 'Parando...',
    continue: 'Continuar',
    resuming: 'Reanudando...',
    switchCamera: 'Cambiar cámara',
    switching: 'Cambiando...',
    record: 'Gravar',
    starting: 'Iniciando...',
    send: 'Enviar',
    sending: 'Enviando...',
    canceling: 'Cancelando...',
    // Permission dialog
    mediaAccess: 'Acceso a medios',
    camera: 'Cámara',
    microphone: 'Micrófono',
    granted: 'Concedido',
    required: 'Requirido',
    skipForNow: 'Saltar por agora',
    tryAgain: 'Tentar de novo',
    grantAccess: 'Conceder acceso',
    continueButton: 'Continuar',
    // Media test dialog
    quickSetupCheck: 'Comprobación rápida de configuración',
    testYour: 'Proba a túa',
    cameraAndMicrophone: 'cámara e micrófono',
    skip: 'Saltar',
    preview: 'Vista previa',
    ensureWorkingProperly: 'para asegurarte de que todo funciona correctamente.',
    linkCopied: 'Ligazón copiada!',
    copyThisLink: 'Copia esta ligazón',
    openInYourBrowser: 'e ábreo no teu navegador.',
    showQuestion: 'Amosar pregunta',
    question: 'Pregunta',
    mediaWarning: 'Esta mensaxe contén ficheiros multimedia',
    showMore: 'Amosar máis',
    showLess: 'Amosar menos',
    // Key error messages
    cameraAccessError: 'Por favor, permite o acceso á cámara e ao micrófono para gravar un vídeo.',
    browserMediaSupport: 'Desafortunadamente, o teu navegador non admite a gravación de medios.',
    enableMicrophoneAccess:
      'Activa o acceso ao micrófono na configuración do navegador para enviar mensaxes de audio.',
  },
  de: {
    typeMessage: 'Nachricht eingeben',
    cancel: 'Abbrechen',
    tapToSend: 'Zum Senden tippen',
    tapToStopRecording: 'Zum Beenden der Aufnahme tippen',
    // Video recording modal
    pause: 'Pausieren',
    pausing: 'Pausiere...',
    stop: 'Stoppen',
    stopping: 'Stoppe...',
    continue: 'Fortsetzen',
    resuming: 'Fortsetzen...',
    switchCamera: 'Kamera wechseln',
    switching: 'Wechsle...',
    record: 'Aufnehmen',
    starting: 'Starte...',
    send: 'Senden',
    sending: 'Sende...',
    canceling: 'Abbrechen...',
    // Permission dialog
    mediaAccess: 'Medienzugriff',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Gewährt',
    required: 'Erforderlich',
    skipForNow: 'Vorerst überspringen',
    tryAgain: 'Erneut versuchen',
    grantAccess: 'Zugriff gewähren',
    continueButton: 'Weiter',
    // Media test dialog
    quickSetupCheck: 'Schnelle Einrichtungsprüfung',
    testYour: 'Testen Sie Ihre',
    cameraAndMicrophone: 'Kamera und Mikrofon',
    skip: 'Überspringen',
    preview: 'Vorschau',
    ensureWorkingProperly: 'um sicherzustellen, dass alles ordnungsgemäß funktioniert.',
    linkCopied: 'Link kopiert!',
    copyThisLink: 'Kopieren Sie diesen Link',
    openInYourBrowser: 'und öffnen Sie ihn in Ihrem Browser.',
    showQuestion: 'Frage anzeigen',
    question: 'Frage',
    mediaWarning: 'Diese Nachricht enthält Mediendateien',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    // Key error messages
    cameraAccessError:
      'Bitte erlauben Sie den Zugriff auf Kamera und Mikrofon, um ein Video aufzunehmen.',
    browserMediaSupport: 'Leider unterstützt Ihr Browser keine Medienaufzeichnung.',
    enableMicrophoneAccess:
      'Aktivieren Sie den Mikrofonzugriff in Ihren Browsereinstellungen, um Audionachrichten zu senden.',
  },
  el: {
    typeMessage: 'Πληκτρολογήστε μήνυμα',
    cancel: 'Ακύρωση',
    tapToSend: 'Πατήστε για αποστολή',
    tapToStopRecording: 'Πατήστε για διακοπή εγγραφής',
    // Video recording modal
    pause: 'Παύση',
    pausing: 'Παύει...',
    stop: 'Στοπ',
    stopping: 'Σταματά...',
    continue: 'Συνέχεια',
    resuming: 'Συνεχίζει...',
    switchCamera: 'Αλλαγή κάμερας',
    switching: 'Αλλάζει...',
    record: 'Εγγραφή',
    starting: 'Αρχίζει...',
    send: 'Αποστολή',
    sending: 'Αποστέλλει...',
    canceling: 'Ακυρώνει...',
    // Permission dialog
    mediaAccess: 'Πρόσβαση στα μέσα',
    camera: 'Κάμερα',
    microphone: 'Μικρόφωνο',
    granted: 'Χορηγήθηκε',
    required: 'Απαιτείται',
    skipForNow: 'Παράλειψη για τώρα',
    tryAgain: 'Δοκιμάστε ξανά',
    grantAccess: 'Χορήγηση πρόσβασης',
    continueButton: 'Συνέχεια',
    // Media test dialog
    quickSetupCheck: 'Γρήγορος έλεγχος ρύθμισης',
    testYour: 'Δοκιμάστε την',
    cameraAndMicrophone: 'κάμερα και το μικρόφωνό σας',
    skip: 'Παράλειψη',
    preview: 'Προεπισκόπηση',
    ensureWorkingProperly: 'για να βεβαιωθείτε ότι όλα λειτουργούν σωστά.',
    linkCopied: 'Ο σύνδεσμος αντιγράφηκε!',
    copyThisLink: 'Αντιγράψτε αυτόν τον σύνδεσμο',
    openInYourBrowser: 'και ανοίξτε τον στον προεπιλεγμένο περιηγητή σας.',
    showQuestion: 'Εμφάνιση ερώτησης',
    question: 'Ερώτηση',
    mediaWarning: 'Αυτό το μήνυμα περιέχει αρχεία πολυμέσων',
    showMore: 'Εμφάνιση περισσότερων',
    showLess: 'Εμφάνιση λιγότερων',
    // Key error messages
    cameraAccessError:
      'Παρακαλώ επιτρέψτε την πρόσβαση στην κάμερα και στο μικρόφωνο για να εγγράψετε ένα βίντεο.',
    browserMediaSupport: 'Δυστυχώς, το πρόγραμμα περιήγησής σας δεν υποστηρίζει εγγραφή πολυμέσων.',
    enableMicrophoneAccess:
      'Ενεργοποιήστε την πρόσβαση στο μικρόφωνο στις ρυθμίσεις του προγράμματος περιήγησης για να στέλνετε ηχητικά μηνύματα.',
  },
  he: {
    typeMessage: 'הקלד הודעה',
    cancel: 'ביטול',
    tapToSend: 'הקש לשליחה',
    tapToStopRecording: 'הקש כדי להפסיק הקלטה',
    // Video recording modal
    pause: 'הקפא',
    pausing: 'מקפיא...',
    stop: 'עצור',
    stopping: 'עוצר...',
    continue: 'המשך',
    resuming: 'ממשיך...',
    switchCamera: 'החלף מצלמה',
    switching: 'מחליף...',
    record: 'הקלט',
    starting: 'מתחיל...',
    send: 'שלח',
    sending: 'שולח...',
    canceling: 'מבטל...',
    // Permission dialog
    mediaAccess: 'גישה למדיה',
    camera: 'מצלמה',
    microphone: 'מיקרופון',
    granted: 'ניתן',
    required: 'נדרש',
    skipForNow: 'דלג לעכשיו',
    tryAgain: 'נסה שוב',
    grantAccess: 'תן גישה',
    continueButton: 'המשך',
    // Media test dialog
    quickSetupCheck: 'בדיקת הגדרה מהירה',
    testYour: 'בדוק את',
    cameraAndMicrophone: 'המצלמה והמיקרופון שלך',
    skip: 'דלג',
    preview: 'תצוגה מקדימה',
    ensureWorkingProperly: 'כדי לוודא שהכל עובד כראוי.',
    linkCopied: 'הקישור הועתק!',
    copyThisLink: 'העתק קישור זה',
    openInYourBrowser: 'ואתחל אותו בדפדפן שלך.',
    showQuestion: 'הצג שאלה',
    question: 'שאלה',
    showMore: 'הצג עוד',
    showLess: 'הצג פחות',
    mediaWarning: 'הודעה זו מכילה קבצי מדיה',
    // Key error messages
    cameraAccessError: 'אנא אפשר גישה למצלמה ולמיקרופון כדי להקליט וידאו.',
    browserMediaSupport: 'למרבה הצער, הדפדפן שלך אינו תומך בהקלטת מדיה.',
    enableMicrophoneAccess: 'הפעל גישה למיקרופון בהגדרות הדפדפן שלך כדי לשלוח הודעות קוליות.',
  },
  iw: {
    typeMessage: 'הקלד הודעה',
    cancel: 'ביטול',
    tapToSend: 'הקש לשליחה',
    tapToStopRecording: 'הקש כדי להפסיק הקלטה',
    // Video recording modal
    pause: 'הקפא',
    pausing: 'מקפיא...',
    stop: 'עצור',
    stopping: 'עוצר...',
    continue: 'המשך',
    resuming: 'ממשיך...',
    switchCamera: 'החלף מצלמה',
    switching: 'מחליף...',
    record: 'הקלט',
    starting: 'מתחיל...',
    send: 'שלח',
    sending: 'שולח...',
    canceling: 'מבטל...',
    // Permission dialog
    mediaAccess: 'גישה למדיה',
    camera: 'מצלמה',
    microphone: 'מיקרופון',
    granted: 'ניתן',
    required: 'נדרש',
    skipForNow: 'דלג לעכשיו',
    tryAgain: 'נסה שוב',
    grantAccess: 'תן גישה',
    continueButton: 'המשך',
    // Media test dialog
    quickSetupCheck: 'בדיקת הגדרה מהירה',
    testYour: 'בדוק את',
    cameraAndMicrophone: 'המצלמה והמיקרופון שלך',
    skip: 'דלג',
    preview: 'תצוגה מקדימה',
    ensureWorkingProperly: 'כדי לוודא שהכל עובד כראוי.',
    linkCopied: 'הקישור הועתק!',
    copyThisLink: 'העתק קישור זה',
    openInYourBrowser: 'ואתחל אותו בדפדפן שלך.',
    showQuestion: 'הצג שאלה',
    question: 'שאלה',
    showMore: 'הצג עוד',
    showLess: 'הצג פחות',
    mediaWarning: 'הודעה זו מכילה קבצי מדיה',
    // Key error messages
    cameraAccessError: 'אנא אפשר גישה למצלמה ולמיקרופון כדי להקליט וידאו.',
    browserMediaSupport: 'למרבה הצער, הדפדפן שלך אינו תומך בהקלטת מדיה.',
    enableMicrophoneAccess: 'הפעל גישה למיקרופון בהגדרות הדפדפן שלך כדי לשלוח הודעות קוליות.',
  },
  hi: {
    typeMessage: 'संदेश टाइप करें',
    cancel: 'रद्द करें',
    tapToSend: 'भेजने के लिए टैप करें',
    tapToStopRecording: 'रिकॉर्डिंग रोकने के लिए टैप करें',
    // Video recording modal
    pause: 'रोकें',
    pausing: 'रोका जा रहा है...',
    stop: 'बंद करें',
    stopping: 'बंद किया जा रहा है...',
    continue: 'जारी रखें',
    resuming: 'फिर से शुरू किया जा रहा है...',
    switchCamera: 'कैमरा बदलें',
    switching: 'बदला जा रहा है...',
    record: 'रिकॉर्ड करें',
    starting: 'शुरू किया जा रहा है...',
    send: 'भेजें',
    sending: 'भेजा जा रहा है...',
    canceling: 'रद्द किया जा रहा है...',
    // Permission dialog
    mediaAccess: 'मीडिया एक्सेस',
    camera: 'कैमरा',
    microphone: 'माइक्रोफोन',
    granted: 'अनुमति दी गई',
    required: 'आवश्यक',
    skipForNow: 'अभी छोड़ें',
    tryAgain: 'फिर से कोशिश करें',
    grantAccess: 'अनुमति दें',
    continueButton: 'जारी रखें',
    // Media test dialog
    quickSetupCheck: 'त्वरित सेटअप जाँच',
    testYour: 'अपने',
    cameraAndMicrophone: 'कैमरा और माइक्रोफ़ोन की जाँच करें',
    skip: 'छोड़ें',
    preview: 'पूर्वावलोकन',
    ensureWorkingProperly: 'सुनिश्चित करने के लिए कि सब कुछ सही ढंग से काम कर रहा है।',
    linkCopied: 'लिंक कॉपी किया गया!',
    copyThisLink: 'इस लिंक को कॉपी करें',
    openInYourBrowser: 'और अपने ब्राउज़र में खोलें।',
    showQuestion: 'प्रश्न दिखाएं',
    question: 'प्रश्न',
    showMore: 'अधिक दिखाएं',
    showLess: 'कम दिखाएं',
    mediaWarning: 'इस संदेश में मीडिया फ़ाइलें शामिल हैं',
    // Key error messages
    cameraAccessError: 'वीडियो रिकॉर्ड करने के लिए कृपया कैमरा और माइक्रोफ़ोन की अनुमति दें।',
    browserMediaSupport: 'दुर्भाग्य से, आपके ब्राउज़र में मीडिया रिकॉर्डिंग समर्थन नहीं है।',
    enableMicrophoneAccess:
      'ऑडियो संदेश भेजने के लिए अपने ब्राउज़र सेटिंग्स में माइक्रोफ़ोन एक्सेस सक्षम करें।',
  },
  hu: {
    typeMessage: 'Írjon üzenetet',
    cancel: 'Mégse',
    tapToSend: 'Koppintson a küldéshez',
    tapToStopRecording: 'Koppintson a felvétel leállításához',
    // Video recording modal
    pause: 'Szünet',
    pausing: 'Szüneteltetés...',
    stop: 'Leállítás',
    stopping: 'Leállítás...',
    continue: 'Folytatás',
    resuming: 'Folytatás...',
    switchCamera: 'Kamera váltás',
    switching: 'Váltás...',
    record: 'Felvétel',
    starting: 'Indítás...',
    send: 'Küldés',
    sending: 'Küldés...',
    canceling: 'Megszakítás...',
    // Permission dialog
    mediaAccess: 'Média hozzáférés',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Engedélyezve',
    required: 'Szükséges',
    skipForNow: 'Kihagyás egyelőre',
    tryAgain: 'Próbálja újra',
    grantAccess: 'Hozzáférés engedélyezése',
    continueButton: 'Folytatás',
    // Media test dialog
    quickSetupCheck: 'Gyors beállítási ellenőrzés',
    testYour: 'Tesztelje a',
    cameraAndMicrophone: 'kamerát és mikrofont',
    skip: 'Kihagyás',
    preview: 'Előnézet',
    ensureWorkingProperly: 'hogy megbizonyosodjon arról, hogy minden megfelelően működik.',
    linkCopied: 'Hivatkozás másolva!',
    copyThisLink: 'Másolja ezt a hivatkozást',
    openInYourBrowser: 'és nyissa meg a böngészőjében.',
    showQuestion: 'Kérdés megjelenítése',
    question: 'Kérdés',
    showMore: 'Mutass többet',
    showLess: 'Mutass kevesebbet',
    mediaWarning: 'Ez az üzenet médiafájlokat tartalmaz',
    // Key error messages
    cameraAccessError:
      'Kérjük, engedélyezze a kamera és mikrofon hozzáférést a videó rögzítéséhez.',
    browserMediaSupport: 'Sajnos a böngészője nem támogatja a média rögzítést.',
    enableMicrophoneAccess:
      'Engedélyezze a mikrofon hozzáférést a böngésző beállításaiban a hangüzenetek küldéséhez.',
  },
  is: {
    typeMessage: 'Skrifaðu skilaboð',
    cancel: 'Hætta við',
    tapToSend: 'Ýttu til að senda',
    tapToStopRecording: 'Ýttu til að stöðva upptöku',
    // Video recording modal
    pause: 'Hlé',
    pausing: 'Tek hlé...',
    stop: 'Stöðva',
    stopping: 'Stöðva...',
    continue: 'Halda áfram',
    resuming: 'Held áfram...',
    switchCamera: 'Skipta um myndavél',
    switching: 'Skipti um...',
    record: 'Taka upp',
    starting: 'Byrja...',
    send: 'Senda',
    sending: 'Sendi...',
    canceling: 'Hætti við...',
    // Permission dialog
    mediaAccess: 'Miðlaaðgangur',
    camera: 'Myndavél',
    microphone: 'Hljóðnemi',
    granted: 'Veitt',
    required: 'Nauðsynlegt',
    skipForNow: 'Sleppa núna',
    tryAgain: 'Reyndu aftur',
    grantAccess: 'Veita aðgang',
    continueButton: 'Halda áfram',
    // Media test dialog
    quickSetupCheck: 'Flýtiuppsetningarstugging',
    testYour: 'Prófaðu',
    cameraAndMicrophone: 'myndavél og hljóðnema',
    skip: 'Sleppa',
    preview: 'Forskoðun',
    ensureWorkingProperly: 'til að tryggja að allt virki rétt.',
    linkCopied: 'Hlekkur afritaður!',
    copyThisLink: 'Afrita þennan hlekk',
    openInYourBrowser: 'og opnaðu í vafranum þínum.',
    mediaWarning: 'Þessi skilaboð innihalda fjölmiðlaskrár',
    question: 'Spurning',
    showMore: 'Sýna meira',
    showLess: 'Sýna minna',
    // Media test dialog
    showQuestion: 'Sýna spurningu',
    // Key error messages
    cameraAccessError:
      'Vinsamlegast leyfðu aðgang að myndavél og hljóðnema til að taka upp myndband.',
    browserMediaSupport: 'Því miður styður vafrinn þinn ekki miðlaupptöku.',
    enableMicrophoneAccess:
      'Virkjaðu hljóðnemaaðgang í vafrastillingum til að senda hljóðskilaboð.',
  },
  id: {
    typeMessage: 'Ketik pesan',
    cancel: 'Batalkan',
    tapToSend: 'Ketuk untuk mengirim',
    tapToStopRecording: 'Ketuk untuk menghentikan perekaman',
    // Video recording modal
    pause: 'Jeda',
    pausing: 'Menjeda...',
    stop: 'Hentikan',
    stopping: 'Menghentikan...',
    continue: 'Lanjutkan',
    resuming: 'Melanjutkan...',
    switchCamera: 'Ganti kamera',
    switching: 'Mengganti...',
    record: 'Rekam',
    starting: 'Memulai...',
    send: 'Kirim',
    sending: 'Mengirim...',
    canceling: 'Membatalkan...',
    // Permission dialog
    mediaAccess: 'Akses media',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Diberikan',
    required: 'Diperlukan',
    skipForNow: 'Lewati untuk sekarang',
    tryAgain: 'Coba lagi',
    grantAccess: 'Berikan akses',
    continueButton: 'Lanjutkan',
    // Media test dialog
    quickSetupCheck: 'Pemeriksaan pengaturan cepat',
    testYour: 'Uji',
    cameraAndMicrophone: 'kamera dan mikrofon Anda',
    skip: 'Lewati',
    preview: 'Pratinjau',
    ensureWorkingProperly: 'untuk memastikan semuanya berfungsi dengan baik.',
    linkCopied: 'Tautan disalin!',
    copyThisLink: 'Salin tautan ini',
    openInYourBrowser: 'dan buka di browser Anda.',
    showQuestion: 'Tampilkan pertanyaan',
    question: 'Pertanyaan',
    mediaWarning: 'Pesan ini berisi file media',
    showMore: 'Tampilkan lebih banyak',
    showLess: 'Tampilkan lebih sedikit',
    // Key error messages
    cameraAccessError: 'Silakan izinkan akses ke kamera dan mikrofon untuk merekam video.',
    browserMediaSupport: 'Sayangnya, browser Anda tidak mendukung perekaman media.',
    enableMicrophoneAccess:
      'Aktifkan akses mikrofon di pengaturan browser Anda untuk mengirim pesan suara.',
  },
  it: {
    typeMessage: 'Scrivi messaggio',
    cancel: 'Annulla',
    tapToSend: 'Tocca per inviare',
    tapToStopRecording: 'Tocca per interrompere la registrazione',
    // Video recording modal
    pause: 'Pausa',
    pausing: 'Mettendo in pausa...',
    stop: 'Ferma',
    stopping: 'Fermando...',
    continue: 'Continua',
    resuming: 'Riprendendo...',
    switchCamera: 'Cambia fotocamera',
    switching: 'Cambiando...',
    record: 'Registra',
    starting: 'Avviando...',
    send: 'Invia',
    sending: 'Invio in corso...',
    canceling: 'Annullamento...',
    // Permission dialog
    mediaAccess: 'Accesso ai media',
    camera: 'Fotocamera',
    microphone: 'Microfono',
    granted: 'Concesso',
    required: 'Richiesto',
    skipForNow: 'Salta per ora',
    tryAgain: 'Riprova',
    grantAccess: 'Concedi accesso',
    continueButton: 'Continua',
    // Media test dialog
    quickSetupCheck: 'Controllo rapido configurazione',
    testYour: 'Testa la tua',
    cameraAndMicrophone: 'fotocamera e microfono',
    skip: 'Salta',
    preview: 'Anteprima',
    ensureWorkingProperly: 'per assicurarti che tutto funzioni correttamente.',
    linkCopied: 'Link copiato!',
    copyThisLink: 'Copia questo link',
    openInYourBrowser: 'e aprilo nel tuo browser predefinito.',
    showQuestion: 'Mostra domanda',
    question: 'Domanda',
    showMore: 'Mostra di più',
    showLess: 'Mostra di meno',
    mediaWarning: 'Questo messaggio contiene file multimediali',
    // Key error messages
    cameraAccessError:
      "Per favore consenti l'accesso a fotocamera e microfono per registrare un video.",
    browserMediaSupport: 'Purtroppo il tuo browser non supporta la registrazione multimediale.',
    enableMicrophoneAccess:
      "Abilita l'accesso al microfono nelle impostazioni del browser per inviare messaggi audio.",
  },
  ja: {
    typeMessage: 'メッセージを入力',
    cancel: 'キャンセル',
    tapToSend: 'タップして送信',
    tapToStopRecording: 'タップして録音を停止',
    // Video recording modal
    pause: '一時停止',
    pausing: '一時停止中...',
    stop: '停止',
    stopping: '停止中...',
    continue: '続ける',
    resuming: '再開中...',
    switchCamera: 'カメラを切り替え',
    switching: '切り替え中...',
    record: '録画',
    starting: '開始中...',
    send: '送信',
    sending: '送信中...',
    canceling: 'キャンセル中...',
    // Permission dialog
    mediaAccess: 'メディアアクセス',
    camera: 'カメラ',
    microphone: 'マイク',
    granted: '許可済み',
    required: '必要',
    skipForNow: '今はスキップ',
    tryAgain: 'もう一度試す',
    grantAccess: 'アクセスを許可',
    continueButton: '続ける',
    // Media test dialog
    quickSetupCheck: 'クイックセットアップチェック',
    testYour: 'テストする',
    cameraAndMicrophone: 'カメラとマイク',
    skip: 'スキップ',
    preview: 'プレビュー',
    ensureWorkingProperly: 'すべてが正しく機能していることを確認するために。',
    linkCopied: 'リンクがコピーされました！',
    copyThisLink: 'このリンクをコピー',
    openInYourBrowser: 'そして、ブラウザで開いてください。',
    showQuestion: '質問を表示',
    question: '質問',
    showMore: 'もっと見る',
    showLess: '閉じる',
    mediaWarning: 'このメッセージにはメディアファイルが含まれています',
    // Key error messages
    cameraAccessError: 'ビデオを録画するにはカメラとマイクへのアクセスを許可してください。',
    browserMediaSupport: '残念ながら、お使いのブラウザはメディア録画をサポートしていません。',
    enableMicrophoneAccess:
      '音声メッセージを送信するには、ブラウザ設定でマイクへのアクセスを有効にしてください。',
  },
  kn: {
    typeMessage: 'ಸಂದೇಶ ಟೈಪ್ ಮಾಡಿ',
    cancel: 'ರದ್ದುಮಾಡಿ',
    tapToSend: 'ಕಳುಹಿಸಲು ಟ್ಯಾಪ್ ಮಾಡಿ',
    tapToStopRecording: 'ರೆಕಾರ್ಡಿಂಗ್ ನಿಲ್ಲಿಸಲು ಟ್ಯಾಪ್ ಮಾಡಿ',
    // Video recording modal
    pause: 'ವಿರಾಮ',
    pausing: 'ವಿರಾಮ ಮಾಡಲಾಗುತ್ತಿದೆ...',
    stop: 'ನಿಲ್ಲಿಸಿ',
    stopping: 'ನಿಲ್ಲಿಸಲಾಗುತ್ತಿದೆ...',
    continue: 'ಮುಂದುವರಿಸಿ',
    resuming: 'ಪುನಃ ಪ್ರಾರಂಭಿಸಲಾಗುತ್ತಿದೆ...',
    switchCamera: 'ಕ್ಯಾಮೆರಾ ಬದಲಾಯಿಸಿ',
    switching: 'ಬದಲಾಯಿಸಲಾಗುತ್ತಿದೆ...',
    record: 'ರೆಕಾರ್ಡ್ ಮಾಡಿ',
    starting: 'ಪ್ರಾರಂಭಿಸಲಾಗುತ್ತಿದೆ...',
    send: 'ಕಳುಹಿಸಿ',
    sending: 'ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ...',
    canceling: 'ರದ್ದುಮಾಡಲಾಗುತ್ತಿದೆ...',
    // Permission dialog
    mediaAccess: 'ಮಾಧ್ಯಮ ಪ್ರವೇಶ',
    camera: 'ಕ್ಯಾಮೆರಾ',
    microphone: 'ಮೈಕ್ರೋಫೋನ್',
    granted: 'ಅನುಮತಿ ನೀಡಲಾಗಿದೆ',
    required: 'ಅಗತ್ಯ',
    skipForNow: 'ಈಗ ಬಿಟ್ಟುಬಿಡಿ',
    tryAgain: 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
    grantAccess: 'ಪ್ರವೇಶ ನೀಡಿ',
    continueButton: 'ಮುಂದುವರಿಸಿ',
    // Media test dialog
    quickSetupCheck: 'ಶೀಘ್ರ ಸೆಟ್ಅಪ್ ಪರಿಶೀಲನೆ',
    testYour: 'ನಿಮ್ಮ',
    cameraAndMicrophone: 'ಕ್ಯಾಮೆರಾ ಮತ್ತು ಮೈಕ್ರೋಫೋನ್ ಪರೀಕ್ಷಿಸಿ',
    skip: 'ಬಿಟ್ಟುಬಿಡಿ',
    preview: 'ಮುನ್ನೋಟ',
    ensureWorkingProperly: 'ಎಲ್ಲವೂ ಸರಿಯಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತಿರುವುದನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು.',
    linkCopied: 'ಲಿಂಕ್ ನಕಲಿಸಲಾಗಿದೆ!',
    copyThisLink: 'ಈ ಲಿಂಕ್ ನಕಲಿಸಿ',
    openInYourBrowser: 'ಮತ್ತು ನಿಮ್ಮ ಬ್ರೌಸರ್‌ನಲ್ಲಿ ತೆರೆಯಿರಿ.',
    showQuestion: 'ಪ್ರಶ್ನೆಯನ್ನು ತೋರಿಸಿ',
    question: 'ಪ್ರಶ್ನೆ',
    mediaWarning: 'ಈ ಸಂದೇಶದಲ್ಲಿ ಮಾಧ್ಯಮ ಕಡತಗಳು ಸೇರಿವೆ',
    showMore: 'ಹೆಚ್ಚು ತೋರಿಸಿ',
    showLess: 'ಕಡಿಮೆ ತೋರಿಸಿ',
    // Key error messages
    cameraAccessError:
      'ವಿಡಿಯೋ ರೆಕಾರ್ಡ್ ಮಾಡಲು ದಯವಿಟ್ಟು ಕ್ಯಾಮೆರಾ ಮತ್ತು ಮೈಕ್ರೋಫೋನ್ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ.',
    browserMediaSupport: 'ದುರದೃಷ್ಟವಶಾತ್, ನಿಮ್ಮ ಬ್ರೌಸರ್ ಮಿಡಿಯಾ ರೆಕಾರ್ಡಿಂಗ್ ಬೆಂಬಲವನ್ನು ಹೊಂದಿಲ್ಲ.',
    enableMicrophoneAccess:
      'ಆಡಿಯೋ ಸಂದೇಶಗಳನ್ನು ಕಳುಹಿಸಲು ನಿಮ್ಮ ಬ್ರೌಸರ್ ಸೆಟ್ಟಿಂಗ್ಗಳಲ್ಲಿ ಮೈಕ್ರೋಫೋನ್ ಪ್ರವೇಶವನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ.',
  },
  kk: {
    typeMessage: 'Хабарлама жазыңыз',
    cancel: 'Болдырмау',
    tapToSend: 'Жіберу үшін түртіңіз',
    tapToStopRecording: 'Жазуды тоқтату үшін түртіңіз',
    // Video recording modal
    pause: 'Кідірту',
    pausing: 'Кідіртілуде...',
    stop: 'Тоқтату',
    stopping: 'Тоқтатылуда...',
    continue: 'Жалғастыру',
    resuming: 'Жалғастырылуда...',
    switchCamera: 'Камераны ауыстыру',
    switching: 'Ауыстырылуда...',
    record: 'Жазу',
    starting: 'Басталуда...',
    send: 'Жіберу',
    sending: 'Жіберілуде...',
    canceling: 'Болдырмауда...',
    // Permission dialog
    mediaAccess: 'Медиаға қол жетімділік',
    camera: 'Камера',
    microphone: 'Микрофон',
    granted: 'Берілді',
    required: 'Қажет',
    skipForNow: 'Қазір өткізіп жіберу',
    tryAgain: 'Қайтадан көріңіз',
    grantAccess: 'Қол жетімділік беру',
    continueButton: 'Жалғастыру',
    // Media test dialog
    quickSetupCheck: 'Жылдам орнату тексеруі',
    testYour: 'Тексеріңіз',
    cameraAndMicrophone: 'камера және микрофон',
    skip: 'Өткізіп жіберу',
    preview: 'Алдын ала қарау',
    ensureWorkingProperly: 'барлығының дұрыс жұмыс істеп тұрғанын тексеру үшін.',
    linkCopied: 'Сілтеме көшірілді!',
    copyThisLink: 'Бұл сілтемені көшіріңіз',
    openInYourBrowser: 'және оны шолғышыңызда ашыңыз.',
    showQuestion: 'Сұрақты көрсету',
    question: 'Сұрақ',
    mediaWarning: 'Бұл хабарлама медиа файлдарын қамтиды',
    showMore: 'Көбірек көрсету',
    showLess: 'Аз көрсету',
    // Key error messages
    cameraAccessError: 'Бейне түсіру үшін камера мен микрофонға қол жетімділікті қосыңыз.',
    browserMediaSupport: 'Өкінішке орай, сіздің шолғышыңыз медиа жазуды қолдамайды.',
    enableMicrophoneAccess:
      'Дыбыстық хабарларды жіберу үшін шолғыш параметрлерінде микрофонға қол жетімділікті қосыңыз.',
  },
  ko: {
    typeMessage: '메시지 입력',
    cancel: '취소',
    tapToSend: '전송하려면 탭하세요',
    tapToStopRecording: '녹음을 중지하려면 탭하세요',
    // Video recording modal
    pause: '일시정지',
    pausing: '일시정지 중...',
    stop: '중지',
    stopping: '중지 중...',
    continue: '계속',
    resuming: '재개 중...',
    switchCamera: '카메라 전환',
    switching: '전환 중...',
    record: '녹화',
    starting: '시작 중...',
    send: '전송',
    sending: '전송 중...',
    canceling: '취소 중...',
    // Permission dialog
    mediaAccess: '미디어 액세스',
    camera: '카메라',
    microphone: '마이크',
    granted: '허용됨',
    required: '필요함',
    skipForNow: '지금 건너뛰기',
    tryAgain: '다시 시도',
    grantAccess: '액세스 허용',
    continueButton: '계속',
    // Media test dialog
    quickSetupCheck: '빠른 설정 확인',
    testYour: '테스트해보세요',
    cameraAndMicrophone: '카메라와 마이크',
    skip: '건너뛰기',
    preview: '미리보기',
    ensureWorkingProperly: '모든 것이 제대로 작동하는지 확인하기 위해.',
    linkCopied: '링크가 복사되었습니다!',
    copyThisLink: '이 링크를 복사하세요',
    openInYourBrowser: '그리고 브라우저에서 열어보세요.',
    showQuestion: '질문 표시',
    question: '질문',
    showMore: '더 보기',
    showLess: '간략히 보기',
    mediaWarning: '이 메시지에는 미디어 파일이 포함되어 있습니다',
    // Key error messages
    cameraAccessError: '비디오를 녹화하려면 카메라와 마이크 액세스를 허용해주세요.',
    browserMediaSupport: '죄송합니다. 브라우저가 미디어 녹화를 지원하지 않습니다.',
    enableMicrophoneAccess:
      '음성 메시지를 보내려면 브라우저 설정에서 마이크 액세스를 활성화하세요.',
  },
  mk: {
    typeMessage: 'Напишете порака',
    cancel: 'Откажи',
    tapToSend: 'Допрете за испраќање',
    tapToStopRecording: 'Допрете за да запрете снимање',
    // Video recording modal
    pause: 'Пауза',
    pausing: 'Паузирање...',
    stop: 'Стоп',
    stopping: 'Спирање...',
    continue: 'Продолжи',
    resuming: 'Продолжување...',
    switchCamera: 'Смени камера',
    switching: 'Сменување...',
    record: 'Снимај',
    starting: 'Започнување...',
    send: 'Испрати',
    sending: 'Испраќање...',
    canceling: 'Откажување...',
    // Permission dialog
    mediaAccess: 'Пристап до медиуми',
    camera: 'Камера',
    microphone: 'Микрофон',
    granted: 'Дозволено',
    required: 'Потребно',
    skipForNow: 'Прескокни засега',
    tryAgain: 'Обиди се повторно',
    grantAccess: 'Дозволи пристап',
    continueButton: 'Продолжи',
    // Media test dialog
    quickSetupCheck: 'Брза проверка на поставки',
    testYour: 'Тестирајте ја вашата',
    cameraAndMicrophone: 'камера и микрофон',
    skip: 'Прескокни',
    preview: 'Преглед',
    ensureWorkingProperly: 'за да се осигурате дека сè функционира правилно.',
    linkCopied: 'Линкот е копиран!',
    copyThisLink: 'Копирајте го овој линк',
    openInYourBrowser: 'и отворете го во вашиот прелистувач.',
    showQuestion: 'Прикажи прашање',
    question: 'Прашање',
    mediaWarning: 'Оваа порака содржи медиумски датотеки',
    showMore: 'Прикажи повеќе',
    showLess: 'Прикажи помалку',
    // Key error messages
    cameraAccessError: 'Ве молиме дозволете пристап до камерата и микрофонот за снимање видео.',
    browserMediaSupport: 'За жал, вашиот прелистувач не поддржува снимање медиуми.',
    enableMicrophoneAccess:
      'Овозможете пристап до микрофонот во поставките на прелистувачот за да испраќате аудио пораки.',
  },
  ms: {
    typeMessage: 'Taip mesej',
    cancel: 'Batal',
    tapToSend: 'Ketik untuk hantar',
    tapToStopRecording: 'Ketik untuk berhenti merakam',
    // Video recording modal
    pause: 'Jeda',
    pausing: 'Menjeda...',
    stop: 'Berhenti',
    stopping: 'Berhenti...',
    continue: 'Teruskan',
    resuming: 'Meneruskan...',
    switchCamera: 'Tukar kamera',
    switching: 'Menukar...',
    record: 'Rakam',
    starting: 'Memulakan...',
    send: 'Hantar',
    sending: 'Menghantar...',
    canceling: 'Membatalkan...',
    // Permission dialog
    mediaAccess: 'Akses Media',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Dibenarkan',
    required: 'Diperlukan',
    skipForNow: 'Langkau buat masa ini',
    tryAgain: 'Cuba lagi',
    grantAccess: 'Berikan akses',
    continueButton: 'Teruskan',
    // Media test dialog
    quickSetupCheck: 'Semakan persediaan pantas',
    testYour: 'Uji',
    cameraAndMicrophone: 'kamera dan mikrofon anda',
    skip: 'Langkau',
    preview: 'Pratonton',
    ensureWorkingProperly: 'untuk memastikan bahawa semuanya berfungsi dengan baik.',
    linkCopied: 'Pautan disalin!',
    copyThisLink: 'Salin pautan ini',
    openInYourBrowser: 'dan buka di pelayar anda.',
    showQuestion: 'Tunjukkan soalan',
    question: 'Soalan',
    mediaWarning: 'Mesej ini mengandungi fail media',
    showMore: 'Tunjukkan lebih banyak',
    showLess: 'Tunjukkan kurang',
    // Key error messages
    cameraAccessError: 'Sila benarkan akses kamera dan mikrofon untuk merakam video.',
    browserMediaSupport: 'Malangnya, penyemak imbas anda tidak menyokong rakaman media.',
    enableMicrophoneAccess:
      'Dayakan akses mikrofon dalam tetapan penyemak imbas anda untuk menghantar mesej audio.',
  },
  mi: {
    typeMessage: 'Pato karere',
    cancel: 'Whakakore',
    tapToSend: 'Pātō ki te tuku',
    tapToStopRecording: 'Pātō ki te whakamutu te hopu',
    // Video recording modal
    pause: 'Okioki',
    pausing: 'Okioki ana...',
    stop: 'Mutu',
    stopping: 'Mutu ana...',
    continue: 'Haere tonu',
    resuming: 'Tīmata anō...',
    switchCamera: 'Hurihia te kāmera',
    switching: 'Hurihia ana...',
    record: 'Hopu',
    starting: 'Tīmata ana...',
    send: 'Tuku',
    sending: 'Tuku ana...',
    canceling: 'Whakakore ana...',
    // Permission dialog
    mediaAccess: 'Uru ki ngā rauemi',
    camera: 'Kāmera',
    microphone: 'Hopuoro',
    granted: 'Kua whakaaetia',
    required: 'Me hiahia',
    skipForNow: 'Kāpea i tēnei taima',
    tryAgain: 'Ngana anō',
    grantAccess: 'Whakaaetia te uru',
    continueButton: 'Haere tonu',
    // Media test dialog
    quickSetupCheck: 'Takinga whakarite tere',
    testYour: 'Whakamātauria tō',
    cameraAndMicrophone: 'kāmera me te hopuoro',
    skip: 'Kāpea',
    preview: 'Arokite',
    ensureWorkingProperly: 'kia mārama ai kei te mahi tika ngā mea katoa.',
    linkCopied: 'Kua kapea te hono!',
    copyThisLink: 'Kapea tēnei hono',
    openInYourBrowser: 'ka whakatuwhera i tō tirotiro.',
    showQuestion: 'Whakaatu pātai',
    question: 'Pātai',
    mediaWarning: 'He kōnae pāpāho kei roto i tēnei karere',
    showMore: 'Whakaatu atu',
    showLess: 'Whakaatu iti',
    // Key error messages
    cameraAccessError: 'Tēnā koa whakaaetia te uru ki te kāmera me te hopuoro ki te hopu ataata.',
    browserMediaSupport: 'Me whakapouri, kāore tō patarakau e tautoko ana i te hopu pāpāho.',
    enableMicrophoneAccess:
      'Whakahohea te uru hopuoro i ngā tautuhinga patarakau kia tuku karere oro.',
  },
  mr: {
    typeMessage: 'संदेश टाइप करा',
    cancel: 'रद्द करा',
    tapToSend: 'पाठवण्यासाठी टॅप करा',
    tapToStopRecording: 'रेकॉर्डिंग थांबवण्यासाठी टॅप करा',
    // Video recording modal
    pause: 'थांबवा',
    pausing: 'थांबवत आहे...',
    stop: 'बंद करा',
    stopping: 'बंद करत आहे...',
    continue: 'सुरू ठेवा',
    resuming: 'पुन्हा सुरू करत आहे...',
    switchCamera: 'कॅमेरा बदला',
    switching: 'बदलत आहे...',
    record: 'रेकॉर्ड करा',
    starting: 'सुरू करत आहे...',
    send: 'पाठवा',
    sending: 'पाठवत आहे...',
    canceling: 'रद्द करत आहे...',
    // Permission dialog
    mediaAccess: 'मीडिया प्रवेश',
    camera: 'कॅमेरा',
    microphone: 'मायक्रोफोन',
    granted: 'मंजूर केले',
    required: 'आवश्यक',
    skipForNow: 'आता वगळा',
    tryAgain: 'पुन्हा प्रयत्न करा',
    grantAccess: 'प्रवेश द्या',
    continueButton: 'सुरू ठेवा',
    // Media test dialog
    quickSetupCheck: 'जलद सेटअप तपासणी',
    testYour: 'तुमच्या',
    cameraAndMicrophone: 'कॅमेरा आणि मायक्रोफोनची चाचणी करा',
    skip: 'वगळा',
    preview: 'पूर्वावलोकन',
    ensureWorkingProperly: 'सर्व काही योग्यरित्या कार्यरत आहे याची खात्री करण्यासाठी.',
    linkCopied: 'लिंक कॉपी केली गेली!',
    copyThisLink: 'ही लिंक कॉपी करा',
    openInYourBrowser: 'आणि आपल्या ब्राउझरमध्ये उघडा.',
    showQuestion: 'प्रश्न दर्शवा',
    question: 'प्रश्न',
    mediaWarning: 'या संदेशात मीडिया फाइल्स समाविष्ट आहेत',
    showMore: 'अधिक दर्शवा',
    showLess: 'कमी दर्शवा',
    // Key error messages
    cameraAccessError:
      'व्हिडिओ रेकॉर्ड करण्यासाठी कृपया कॅमेरा आणि मायक्रोफोन प्रवेशाला परवानगी द्या.',
    browserMediaSupport: 'दुर्दैवाने, तुमच्या ब्राउझरमध्ये मीडिया रेकॉर्डिंग समर्थन नाही.',
    enableMicrophoneAccess:
      'ऑडिओ संदेश पाठवण्यासाठी आपल्या ब्राउझर सेटिंग्जमध्ये मायक्रोफोन प्रवेश सक्षम करा.',
  },
  pa: {
    typeMessage: 'ਸੁਨੇਹਾ ਟਾਈਪ ਕਰੋ',
    cancel: 'ਰੱਦ ਕਰੋ',
    tapToSend: 'ਭੇਜਣ ਲਈ ਟੈਪ ਕਰੋ',
    tapToStopRecording: 'ਰਿਕਾਰਡਿੰਗ ਬੰਦ ਕਰਨ ਲਈ ਟੈਪ ਕਰੋ',
    // Video recording modal
    pause: 'ਵਿਰਾਮ',
    pausing: 'ਵਿਰਾਮ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...',
    stop: 'ਰੋਕੋ',
    stopping: 'ਰੋਕਿਆ ਜਾ ਰਿਹਾ ਹੈ...',
    continue: 'ਜਾਰੀ ਰੱਖੋ',
    resuming: 'ਮੁੜ ਸ਼ੁਰੂ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...',
    switchCamera: 'ਕੈਮਰਾ ਬਦਲੋ',
    switching: 'ਬਦਲਿਆ ਜਾ ਰਿਹਾ ਹੈ...',
    record: 'ਰਿਕਾਰਡ ਕਰੋ',
    starting: 'ਸ਼ੁਰੂ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...',
    send: 'ਭੇਜੋ',
    sending: 'ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ...',
    canceling: 'ਰੱਦ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...',
    // Permission dialog
    mediaAccess: 'ਮੀਡੀਆ ਪਹੁੰਚ',
    camera: 'ਕੈਮਰਾ',
    microphone: 'ਮਾਈਕ੍ਰੋਫੋਨ',
    granted: 'ਦਿੱਤੀ ਗਈ',
    required: 'ਲੋੜੀਂਦਾ',
    skipForNow: 'ਹੁਣ ਛੱਡੋ',
    tryAgain: 'ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
    grantAccess: 'ਪਹੁੰਚ ਦਿਓ',
    continueButton: 'ਜਾਰੀ ਰੱਖੋ',
    // Media test dialog
    quickSetupCheck: 'ਤੇਜ਼ ਸੈੱਟਅੱਪ ਜਾਂਚ',
    testYour: 'ਆਪਣੇ',
    cameraAndMicrophone: 'ਕੈਮਰਾ ਅਤੇ ਮਾਈਕ੍ਰੋਫੋਨ ਦੀ ਜਾਂਚ ਕਰੋ',
    skip: 'ਛੱਡੋ',
    preview: 'ਪੂਰਵਦਰਸ਼ਨ',
    ensureWorkingProperly: 'ਤਾਂ ਜੋ ਇਹ ਯਕੀਨੀ ਬਣਾਇਆ ਜਾ ਸਕੇ ਕਿ ਸਭ ਕੁਝ ਠੀਕ ਕੰਮ ਕਰ ਰਿਹਾ ਹੈ।',
    linkCopied: 'ਲਿੰਕ ਕਾਪੀ ਕੀਤਾ ਗਿਆ!',
    copyThisLink: 'ਇਹ ਲਿੰਕ ਕਾਪੀ ਕਰੋ',
    openInYourBrowser: 'ਅਤੇ ਆਪਣੇ ਬਰਾਊਜ਼ਰ ਵਿੱਚ ਖੋਲ੍ਹੋ।',
    showQuestion: 'ਸਵਾਲ ਦਿਖਾਓ',
    question: 'ਸਵਾਲ',
    mediaWarning: 'ਇਸ ਸੁਨੇਹੇ ਵਿੱਚ ਮੀਡੀਆ ਫਾਈਲਾਂ ਸ਼ਾਮਲ ਹਨ',
    showMore: 'ਹੋਰ ਦਿਖਾਓ',
    showLess: 'ਘੱਟ ਦਿਖਾਓ',
    // Key error messages
    cameraAccessError:
      'ਵੀਡੀਓ ਰਿਕਾਰਡ ਕਰਨ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਕੈਮਰਾ ਅਤੇ ਮਾਈਕ੍ਰੋਫੋਨ ਤੱਕ ਪਹੁੰਚ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ।',
    browserMediaSupport: 'ਅਫਸੋਸ, ਤੁਹਾਡਾ ਬ੍ਰਾਊਜ਼ਰ ਮੀਡੀਆ ਰਿਕਾਰਡਿੰਗ ਦਾ ਸਮਰਥਨ ਨਹੀਂ ਕਰਦਾ।',
    enableMicrophoneAccess:
      'ਆਡੀਓ ਸੁਨੇਹੇ ਭੇਜਣ ਲਈ ਆਪਣੇ ਬ੍ਰਾਊਜ਼ਰ ਸੈਟਿੰਗਾਂ ਵਿੱਚ ਮਾਈਕ੍ਰੋਫੋਨ ਪਹੁੰਚ ਨੂੰ ਸਮਰੱਥ ਕਰੋ।',
  },
  fa: {
    typeMessage: 'پیام را تایپ کنید',
    cancel: 'لغو',
    tapToSend: 'برای ارسال ضربه بزنید',
    tapToStopRecording: 'برای توقف ضبط ضربه بزنید',
    // Video recording modal
    pause: 'توقف',
    pausing: 'در حال توقف...',
    stop: 'متوقف',
    stopping: 'در حال متوقف کردن...',
    continue: 'ادامه',
    resuming: 'در حال ادامه...',
    switchCamera: 'تعویض دوربین',
    switching: 'در حال تعویض...',
    record: 'ضبط',
    starting: 'در حال شروع...',
    send: 'ارسال',
    sending: 'در حال ارسال...',
    canceling: 'در حال لغو...',
    // Permission dialog
    mediaAccess: 'دسترسی به رسانه',
    camera: 'دوربین',
    microphone: 'میکروفون',
    granted: 'اعطا شده',
    required: 'مورد نیاز',
    skipForNow: 'فعلاً رد کنید',
    tryAgain: 'دوباره تلاش کنید',
    grantAccess: 'دسترسی دهید',
    continueButton: 'ادامه',
    // Media test dialog
    quickSetupCheck: 'بررسی سریع تنظیمات',
    testYour: 'آزمایش کنید',
    cameraAndMicrophone: 'دوربین و میکروفون خود را',
    skip: 'رد کردن',
    preview: 'پیش‌نمایش',
    ensureWorkingProperly: 'برای اطمینان از اینکه همه چیز به درستی کار می‌کند.',
    linkCopied: 'لینک کپی شد!',
    copyThisLink: 'این لینک را کپی کنید',
    openInYourBrowser: 'و در مرورگر خود باز کنید.',
    showQuestion: 'نمایش سوال',
    question: 'سوال',
    mediaWarning: 'این پیام شامل فایل‌های رسانه‌ای است',
    showMore: 'نمایش بیشتر',
    showLess: 'نمایش کمتر',
    // Key error messages
    cameraAccessError: 'لطفاً برای ضبط ویدیو به دوربین و میکروفون اجازه دسترسی دهید.',
    browserMediaSupport: 'متأسفانه، مرورگر شما از ضبط رسانه پشتیبانی نمی‌کند.',
    enableMicrophoneAccess:
      'برای ارسال پیام‌های صوتی، دسترسی به میکروفون را در تنظیمات مرورگر فعال کنید.',
  },
  lt: {
    typeMessage: 'Įveskite žinutę',
    cancel: 'Atšaukti',
    tapToSend: 'Bakstelėkite, kad siųsti',
    tapToStopRecording: 'Bakstelėkite, kad sustabdyti įrašymą',
    // Video recording modal
    pause: 'Pristabdyti',
    pausing: 'Pristabdoma...',
    stop: 'Sustabdyti',
    stopping: 'Sustabdomas...',
    continue: 'Tęsti',
    resuming: 'Tęsiama...',
    switchCamera: 'Perjungti kamerą',
    switching: 'Perjungiama...',
    record: 'Įrašyti',
    starting: 'Pradedama...',
    send: 'Siųsti',
    sending: 'Siunčiama...',
    canceling: 'Atšaukiama...',
    // Permission dialog
    mediaAccess: 'Medijos prieiga',
    camera: 'Kamera',
    microphone: 'Mikrofonas',
    granted: 'Leista',
    required: 'Reikalinga',
    skipForNow: 'Dabar praleisti',
    tryAgain: 'Bandykite dar kartą',
    grantAccess: 'Leisti prieigą',
    continueButton: 'Tęsti',
    // Media test dialog
    quickSetupCheck: 'Greitas nustatymų patikrinimas',
    testYour: 'Išbandykite savo',
    cameraAndMicrophone: 'kamerą ir mikrofoną',
    skip: 'Praleisti',
    preview: 'Peržiūra',
    ensureWorkingProperly: 'kad viskas veikia tinkamai.',
    linkCopied: 'Nuoroda nukopijuota!',
    copyThisLink: 'Nukopijuokite šią nuorodą',
    openInYourBrowser: 'ir atidary kite savo naršyklėje.',
    showQuestion: 'Rodyti klausimą',
    question: 'Klausimas',
    mediaWarning: 'Ši žinutė turi medijos failų',
    showMore: 'Rodyti daugiau',
    showLess: 'Rodyti mažiau',
    // Key error messages
    cameraAccessError:
      'Leiskite prieigą prie kameros ir mikrofono, kad galėtumėte įrašyti vaizdo įrašą.',
    browserMediaSupport: 'Deja, jūsų naršyklė nepalaiko medijos įrašymo.',
    enableMicrophoneAccess:
      'Įjunkite mikrofono prieigą naršyklės nustatymuose, kad galėtumėte siųsti garso žinutes.',
  },
  ne: {
    typeMessage: 'सन्देश टाइप गर्नुहोस्',
    cancel: 'रद्द गर्नुहोस्',
    tapToSend: 'पठाउन ट्याप गर्नुहोस्',
    tapToStopRecording: 'रेकर्डिङ रोक्न ट्याप गर्नुहोस्',
    // Video recording modal
    pause: 'विराम',
    pausing: 'विराम गर्दै...',
    stop: 'रोक्नुहोस्',
    stopping: 'रोक्दै...',
    continue: 'जारी राख्नुहोस्',
    resuming: 'पुनः सुरु गर्दै...',
    switchCamera: 'क्यामेरा परिवर्तन गर्नुहोस्',
    switching: 'परिवर्तन गर्दै...',
    record: 'रेकर्ड गर्नुहोस्',
    starting: 'सुरु गर्दै...',
    send: 'पठाउनुहोस्',
    sending: 'पठाउँदै...',
    canceling: 'रद्द गर्दै...',
    // Permission dialog
    mediaAccess: 'मिडिया पहुँच',
    camera: 'क्यामेरा',
    microphone: 'माइक्रोफोन',
    granted: 'अनुमति दिइएको',
    required: 'आवश्यक',
    skipForNow: 'अहिले छोड्नुहोस्',
    tryAgain: 'फेरि प्रयास गर्नुहोस्',
    grantAccess: 'पहुँच दिनुहोस्',
    continueButton: 'जारी राख्नुहोस्',
    // Media test dialog
    quickSetupCheck: 'छिटो सेटअप जाँच',
    testYour: 'तपाईंको परीक्षण गर्नुहोस्',
    cameraAndMicrophone: 'क्यामेरा र माइक्रोफोन',
    skip: 'छोड्नुहोस्',
    preview: 'पूर्वावलोकन',
    ensureWorkingProperly: 'सबै कुरा ठीकसँग काम गरिरहेको छ भनेर सुनिश्चित गर्न।',
    linkCopied: 'लिङ्क प्रतिलिपि गरिएको छ!',
    copyThisLink: 'यो लिङ्क प्रतिलिपि गर्नुहोस्',
    openInYourBrowser: 'र आफ्नो ब्राउजरमा खोल्नुहोस्।',
    showQuestion: 'प्रश्न देखाउनुहोस्',
    question: 'प्रश्न',
    mediaWarning: 'यस सन्देशमा मिडिया फाइलहरू समावेश छन्',
    showMore: 'थप देखाउनुहोस्',
    showLess: 'कम देखाउनुहोस्',
    // Key error messages
    cameraAccessError: 'कृपया भिडियो रेकर्ड गर्न क्यामेरा र माइक्रोफोन पहुँच अनुमति दिनुहोस्।',
    browserMediaSupport: 'दुर्भाग्यवश, तपाईंको ब्राउजर मिडिया रेकर्डिङ समर्थन गर्दैन।',
    enableMicrophoneAccess:
      'अडियो सन्देश पठाउनका लागि आफ्नो ब्राउजर सेटिङहरूमा माइक्रोफोन पहुँच सक्षम गर्नुहोस्।',
  },
  no: {
    typeMessage: 'Skriv melding',
    cancel: 'Avbryt',
    tapToSend: 'Trykk for å sende',
    tapToStopRecording: 'Trykk for å stoppe opptak',
    // Video recording modal
    pause: 'Pause',
    pausing: 'Setter på pause...',
    stop: 'Stopp',
    stopping: 'Stopper...',
    continue: 'Fortsett',
    resuming: 'Gjenopptar...',
    switchCamera: 'Bytt kamera',
    switching: 'Bytter...',
    record: 'Spill inn',
    starting: 'Starter...',
    send: 'Send',
    sending: 'Sender...',
    canceling: 'Avbryter...',
    // Permission dialog
    mediaAccess: 'Medietilgang',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Innvilget',
    required: 'Påkrevd',
    skipForNow: 'Hopp over for nå',
    tryAgain: 'Prøv igjen',
    grantAccess: 'Gi tilgang',
    continueButton: 'Fortsett',
    // Media test dialog
    quickSetupCheck: 'Rask oppsettssjekk',
    testYour: 'Test din',
    cameraAndMicrophone: 'kamera og mikrofon',
    skip: 'Hopp over',
    preview: 'Forhåndsvisning',
    ensureWorkingProperly: 'for å sikre at alt fungerer som det skal.',
    linkCopied: 'Lenke kopiert!',
    copyThisLink: 'Kopier denne lenken',
    openInYourBrowser: 'og åpne den i nettleseren din.',
    showQuestion: 'Vis spørsmål',
    question: 'Spørsmål',
    mediaWarning: 'Denne meldingen inneholder mediefiler',
    showMore: 'Vis mer',
    showLess: 'Vis mindre',
    // Key error messages
    cameraAccessError: 'Vennligst tillat tilgang til kamera og mikrofon for å ta opp video.',
    browserMediaSupport: 'Dessverre støtter ikke nettleseren din medieopptak.',
    enableMicrophoneAccess:
      'Aktiver mikrofontilgang i nettleserinnstillingene for å sende lydmeldinger.',
  },
  pl: {
    typeMessage: 'Wpisz wiadomość',
    cancel: 'Anuluj',
    tapToSend: 'Stuknij, aby wysłać',
    tapToStopRecording: 'Stuknij, aby zatrzymać nagrywanie',
    // Video recording modal
    pause: 'Pauza',
    pausing: 'Wstrzymywanie...',
    stop: 'Zatrzymaj',
    stopping: 'Zatrzymywanie...',
    continue: 'Kontynuuj',
    resuming: 'Wznawianie...',
    switchCamera: 'Przełącz kamerę',
    switching: 'Przełączanie...',
    record: 'Nagrywaj',
    starting: 'Rozpoczynanie...',
    send: 'Wyślij',
    sending: 'Wysyłanie...',
    canceling: 'Anulowanie...',
    // Permission dialog
    mediaAccess: 'Dostęp do mediów',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Przyznane',
    required: 'Wymagane',
    skipForNow: 'Pomiń na razie',
    tryAgain: 'Spróbuj ponownie',
    grantAccess: 'Przyznaj dostęp',
    continueButton: 'Kontynuuj',
    // Media test dialog
    quickSetupCheck: 'Szybkie sprawdzenie konfiguracji',
    testYour: 'Przetestuj swoją',
    cameraAndMicrophone: 'kamerę i mikrofon',
    skip: 'Pomiń',
    preview: 'Podgląd',
    ensureWorkingProperly: 'aby upewnić się, że wszystko działa poprawnie.',
    linkCopied: 'Link skopiowany!',
    copyThisLink: 'Skopiuj ten link',
    openInYourBrowser: 'i otwórz go w swojej przeglądarce.',
    showQuestion: 'Pokaż pytanie',
    question: 'Pytanie',
    mediaWarning: 'Ta wiadomość zawiera pliki multimedialne',
    showMore: 'Pokaż więcej',
    showLess: 'Pokaż mniej',
    // Key error messages
    cameraAccessError: 'Zezwól na dostęp do kamery i mikrofonu, aby nagrać wideo.',
    browserMediaSupport: 'Niestety, Twoja przeglądarka nie obsługuje nagrywania mediów.',
    enableMicrophoneAccess:
      'Włącz dostęp do mikrofonu w ustawieniach przeglądarki, aby wysyłać wiadomości głosowe.',
  },
  pt: {
    typeMessage: 'Digite mensagem',
    cancel: 'Cancelar',
    tapToSend: 'Toque para enviar',
    tapToStopRecording: 'Toque para parar de gravar',
    // Video recording modal
    pause: 'Pausar',
    pausing: 'Pausando...',
    stop: 'Parar',
    stopping: 'Parando...',
    continue: 'Continuar',
    resuming: 'Retomando...',
    switchCamera: 'Trocar câmera',
    switching: 'Trocando...',
    record: 'Gravar',
    starting: 'Iniciando...',
    send: 'Enviar',
    sending: 'Enviando...',
    canceling: 'Cancelando...',
    // Permission dialog
    mediaAccess: 'Acesso à mídia',
    camera: 'Câmera',
    microphone: 'Microfone',
    granted: 'Concedido',
    required: 'Obrigatório',
    skipForNow: 'Pular por agora',
    tryAgain: 'Tentar novamente',
    grantAccess: 'Conceder acesso',
    continueButton: 'Continuar',
    // Media test dialog
    quickSetupCheck: 'Verificação rápida de configuração',
    testYour: 'Teste sua',
    cameraAndMicrophone: 'câmera e microfone',
    skip: 'Pular',
    preview: 'Pré-visualização',
    ensureWorkingProperly: 'para garantir que tudo esteja funcionando corretamente.',
    linkCopied: 'Link copiado!',
    copyThisLink: 'Copie este link',
    openInYourBrowser: 'e abra no seu navegador.',
    showQuestion: 'Pokaż pytanie',
    question: 'Pergunta',
    mediaWarning: 'Esta mensagem contém arquivos de mídia',
    showMore: 'Mostrar mais',
    showLess: 'Mostrar menos',
    // Key error messages
    cameraAccessError: 'Por favor, permita o acesso à câmera e ao microfone para gravar um vídeo.',
    browserMediaSupport: 'Infelizmente, seu navegador não suporta gravação de mídia.',
    enableMicrophoneAccess:
      'Ative o acesso ao microfone nas configurações do navegador para enviar mensagens de áudio.',
  },
  ro: {
    typeMessage: 'Scrieți mesaj',
    cancel: 'Anulare',
    tapToSend: 'Atingeți pentru a trimite',
    tapToStopRecording: 'Atingeți pentru a opri înregistrarea',
    // Video recording modal
    pause: 'Pauză',
    pausing: 'Se pune în pauză...',
    stop: 'Oprire',
    stopping: 'Se oprește...',
    continue: 'Continuă',
    resuming: 'Se reia...',
    switchCamera: 'Schimbă camera',
    switching: 'Se schimbă...',
    record: 'Înregistrează',
    starting: 'Se pornește...',
    send: 'Trimite',
    sending: 'Se trimite...',
    canceling: 'Se anulează...',
    // Permission dialog
    mediaAccess: 'Acces la media',
    camera: 'Camera',
    microphone: 'Microfonul',
    granted: 'Acordat',
    required: 'Necesar',
    skipForNow: 'Omite deocamdată',
    tryAgain: 'Încearcă din nou',
    grantAccess: 'Acordă acces',
    continueButton: 'Continuă',
    // Media test dialog
    quickSetupCheck: 'Verificare rapidă a configurării',
    testYour: 'Testează-ți',
    cameraAndMicrophone: 'camera și microfonul',
    skip: 'Omite',
    preview: 'Previzualizare',
    ensureWorkingProperly: 'pentru a te asigura că totul funcționează corect.',
    linkCopied: 'Link copiat!',
    copyThisLink: 'Copiază acest link',
    openInYourBrowser: 'și deschide-l în browserul tău.',
    showQuestion: 'Arată întrebarea',
    question: 'Întrebare',
    mediaWarning: 'Acest mesaj conține fișiere media',
    showMore: 'Arată mai mult',
    showLess: 'Arată mai puțin',
    // Key error messages
    cameraAccessError:
      'Te rugăm să permiți accesul la cameră și microfon pentru a înregistra un videoclip.',
    browserMediaSupport: 'Din păcate, browserul tău nu suportă înregistrarea media.',
    enableMicrophoneAccess:
      'Activează accesul la microfon în setările browserului pentru a trimite mesaje audio.',
  },
  ru: {
    typeMessage: 'Введите сообщение',
    cancel: 'Отмена',
    tapToSend: 'Нажмите для отправки',
    tapToStopRecording: 'Нажмите, чтобы остановить запись',
    // Video recording modal
    pause: 'Пауза',
    pausing: 'Приостановка...',
    stop: 'Стоп',
    stopping: 'Остановка...',
    continue: 'Продолжить',
    resuming: 'Возобновление...',
    switchCamera: 'Переключить камеру',
    switching: 'Переключение...',
    record: 'Запись',
    starting: 'Запуск...',
    send: 'Отправить',
    sending: 'Отправка...',
    canceling: 'Отмена...',
    // Permission dialog
    mediaAccess: 'Доступ к медиа',
    camera: 'Камера',
    microphone: 'Микрофон',
    granted: 'Предоставлено',
    required: 'Требуется',
    skipForNow: 'Пропустить пока',
    tryAgain: 'Попробовать снова',
    grantAccess: 'Предоставить доступ',
    continueButton: 'Продолжить',
    // Media test dialog
    quickSetupCheck: 'Быстрая проверка настроек',
    testYour: 'Протестируйте вашу',
    cameraAndMicrophone: 'камеру и микрофон',
    skip: 'Пропустить',
    preview: 'Предпросмотр',
    ensureWorkingProperly: 'чтобы убедиться, что все работает правильно.',
    linkCopied: 'Ссылка скопирована!',
    copyThisLink: 'Скопируйте эту ссылку',
    openInYourBrowser: 'и откройте в вашем браузере.',
    showQuestion: 'Показать вопрос',
    question: 'Вопрос',
    mediaWarning: 'Это сообщение содержит медиафайлы',
    showMore: 'Показать больше',
    showLess: 'Показать меньше',
    // Key error messages
    cameraAccessError: 'Пожалуйста, разрешите доступ к камере и микрофону для записи видео.',
    browserMediaSupport: 'К сожалению, ваш браузер не поддерживает запись медиа.',
    enableMicrophoneAccess:
      'Включите доступ к микрофону в настройках браузера для отправки аудиосообщений.',
  },
  sr: {
    typeMessage: 'Унесите поруку',
    cancel: 'Откажи',
    tapToSend: 'Додирните за слање',
    tapToStopRecording: 'Додирните да зауставите снимање',
    // Video recording modal
    pause: 'Пауза',
    pausing: 'Паузирање...',
    stop: 'Стоп',
    stopping: 'Заустављање...',
    continue: 'Настави',
    resuming: 'Настављање...',
    switchCamera: 'Промени камеру',
    switching: 'Мењање...',
    record: 'Снимај',
    starting: 'Покретање...',
    send: 'Пошаљи',
    sending: 'Слање...',
    canceling: 'Отказивање...',
    // Permission dialog
    mediaAccess: 'Приступ медијима',
    camera: 'Камера',
    microphone: 'Микрофон',
    granted: 'Одобрено',
    required: 'Потребно',
    skipForNow: 'Прескочи за сада',
    tryAgain: 'Покушај поново',
    grantAccess: 'Одобри приступ',
    continueButton: 'Настави',
    // Media test dialog
    quickSetupCheck: 'Брза провера подешавања',
    testYour: 'Тестирајте вашу',
    cameraAndMicrophone: 'камеру и микрофон',
    skip: 'Прескочи',
    preview: 'Преглед',
    ensureWorkingProperly: 'да бисте били сигурни да све функционише исправно.',
    linkCopied: 'Линк је копиран!',
    copyThisLink: 'Копирајте овај линк',
    openInYourBrowser: 'и отворите га у вашем прегледачу.',
    showQuestion: 'Прикажи питање',
    question: 'Питање',
    mediaWarning: 'Ова порука садржи медијске датотеке',
    showMore: 'Прикажи више',
    showLess: 'Прикажи мање',
    // Key error messages
    cameraAccessError: 'Молимо дозволите приступ камери и микрофону за снимање видеа.',
    browserMediaSupport: 'Нажалост, ваш прегледач не подржава снимање медија.',
    enableMicrophoneAccess:
      'Омогућите приступ микрофону у подешавањима прегледача за слање аудио порука.',
  },
  sk: {
    typeMessage: 'Napíšte správu',
    cancel: 'Zrušiť',
    tapToSend: 'Ťuknutím odošlete',
    tapToStopRecording: 'Ťuknutím zastavíte nahrávanie',
    // Video recording modal
    pause: 'Pauza',
    pausing: 'Pozastavovanie...',
    stop: 'Zastaviť',
    stopping: 'Zastavovanie...',
    continue: 'Pokračovať',
    resuming: 'Obnovovanie...',
    switchCamera: 'Prepnúť kameru',
    switching: 'Prepínanie...',
    record: 'Nahrávať',
    starting: 'Spúšťanie...',
    send: 'Odoslať',
    sending: 'Odosielanie...',
    canceling: 'Rušenie...',
    // Permission dialog
    mediaAccess: 'Prístup k médiám',
    camera: 'Kamera',
    microphone: 'Mikrofón',
    granted: 'Povolené',
    required: 'Požadované',
    skipForNow: 'Zatiaľ preskočiť',
    tryAgain: 'Skúsiť znovu',
    grantAccess: 'Povoliť prístup',
    continueButton: 'Pokračovať',
    // Media test dialog
    quickSetupCheck: 'Rýchla kontrola nastavenia',
    testYour: 'Otestujte svoju',
    cameraAndMicrophone: 'kameru a mikrofón',
    skip: 'Preskočiť',
    preview: 'Náhľad',
    ensureWorkingProperly: 'aby ste sa uistili, že všetko funguje správne.',
    linkCopied: 'Odkaz skopírovaný!',
    copyThisLink: 'Skopírujte tento odkaz',
    openInYourBrowser: 'a otvorte ho vo svojom prehliadači.',
    showQuestion: 'Zobraziť otázku',
    question: 'Otázka',
    mediaWarning: 'Táto správa obsahuje mediálne súbory',
    showMore: 'Zobraziť viac',
    showLess: 'Zobraziť menej',
    // Key error messages
    cameraAccessError: 'Prosím povoľte prístup ku kamere a mikrofónu pre nahrávanie videa.',
    browserMediaSupport: 'Bohužiaľ váš prehliadač nepodporuje nahrávanie médií.',
    enableMicrophoneAccess:
      'Povoľte prístup k mikrofónu v nastaveniach prehliadača pre odosielanie zvukových správ.',
  },
  sl: {
    typeMessage: 'Vnesite sporočilo',
    cancel: 'Prekliči',
    tapToSend: 'Tapnite za pošiljanje',
    tapToStopRecording: 'Tapnite za ustavitev snemanja',
    // Video recording modal
    pause: 'Pavza',
    pausing: 'Pavziranje...',
    stop: 'Ustavi',
    stopping: 'Ustavljanje...',
    continue: 'Nadaljuj',
    resuming: 'Nadaljevanje...',
    switchCamera: 'Preklopi kamero',
    switching: 'Preklapljanje...',
    record: 'Posnemi',
    starting: 'Zaganjanje...',
    send: 'Pošlji',
    sending: 'Pošiljanje...',
    canceling: 'Preklic...',
    // Permission dialog
    mediaAccess: 'Dostop do medijev',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Odobreno',
    required: 'Potrebno',
    skipForNow: 'Preskoči za zdaj',
    tryAgain: 'Poskusi znova',
    grantAccess: 'Odobri dostop',
    continueButton: 'Nadaljuj',
    // Media test dialog
    quickSetupCheck: 'Hitra preverba nastavitev',
    testYour: 'Preizkusite svojo',
    cameraAndMicrophone: 'kamero in mikrofon',
    skip: 'Preskoči',
    preview: 'Predogled',
    ensureWorkingProperly: 'da zagotovite, da vse deluje pravilno.',
    linkCopied: 'Povezava je bila kopirana!',
    copyThisLink: 'Kopirajte to povezavo',
    openInYourBrowser: 'in jo odprite v svojem brskalniku.',
    showQuestion: 'Prikaži vprašanje',
    question: 'Vprašanje',
    mediaWarning: 'To sporočilo vsebuje medijske datoteke',
    showMore: 'Prikaži več',
    showLess: 'Prikaži manj',
    // Key error messages
    cameraAccessError: 'Prosim dovolite dostop do kamere in mikrofona za snemanje videa.',
    browserMediaSupport: 'Žal vaš brskalnik ne podpira snemanja medijev.',
    enableMicrophoneAccess:
      'Omogočite dostop do mikrofona v nastavitvah brskalnika za pošiljanje zvočnih sporočil.',
  },
  es: {
    typeMessage: 'Escribir mensaje',
    cancel: 'Cancelar',
    tapToSend: 'Toca para enviar',
    tapToStopRecording: 'Toca para detener la grabación',
    // Video recording modal
    pause: 'Pausar',
    pausing: 'Pausando...',
    stop: 'Detener',
    stopping: 'Deteniendo...',
    continue: 'Continuar',
    resuming: 'Reanudando...',
    switchCamera: 'Cambiar cámara',
    switching: 'Cambiando...',
    record: 'Grabar',
    starting: 'Iniciando...',
    send: 'Enviar',
    sending: 'Enviando...',
    canceling: 'Cancelando...',
    // Permission dialog
    mediaAccess: 'Acceso a medios',
    camera: 'Cámara',
    microphone: 'Micrófono',
    granted: 'Concedido',
    required: 'Requerido',
    skipForNow: 'Omitir por ahora',
    tryAgain: 'Intentar de nuevo',
    grantAccess: 'Conceder acceso',
    continueButton: 'Continuar',
    // Media test dialog
    quickSetupCheck: 'Verificación rápida de configuración',
    testYour: 'Prueba tu',
    cameraAndMicrophone: 'cámara y micrófono',
    skip: 'Omitir',
    preview: 'Vista previa',
    ensureWorkingProperly: 'para asegurarte de que todo funcione correctamente.',
    linkCopied: '¡Enlace copiado!',
    copyThisLink: 'Copia este enlace',
    openInYourBrowser: 'y ábrelo en tu navegador.',
    showQuestion: 'Mostrar pregunta',
    question: 'Pregunta',
    mediaWarning: 'Este mensaje contiene archivos multimedia',
    showMore: 'Mostrar más',
    showLess: 'Mostrar menos',
    // Key error messages
    cameraAccessError:
      'Por favor permite el acceso a la cámara y al micrófono para grabar un video.',
    browserMediaSupport: 'Lamentablemente, tu navegador no admite la grabación de medios.',
    enableMicrophoneAccess:
      'Habilita el acceso al micrófono en la configuración del navegador para enviar mensajes de audio.',
  },
  sw: {
    typeMessage: 'Andika ujumbe',
    cancel: 'Ghairi',
    tapToSend: 'Gusa kutuma',
    tapToStopRecording: 'Gusa kuacha kurekodi',
    // Video recording modal
    pause: 'Simama',
    pausing: 'Inasimama...',
    stop: 'Acha',
    stopping: 'Inaacha...',
    continue: 'Endelea',
    resuming: 'Inaendelea...',
    switchCamera: 'Badilisha kamera',
    switching: 'Inabadilisha...',
    record: 'Rekodi',
    starting: 'Inaanza...',
    send: 'Tuma',
    sending: 'Inatuma...',
    canceling: 'Inaghairi...',
    // Permission dialog
    mediaAccess: 'Ufikiaji wa Media',
    camera: 'Kamera',
    microphone: 'Kipaza sauti',
    granted: 'Imeidhinishwa',
    required: 'Inahitajika',
    skipForNow: 'Ruka kwa sasa',
    tryAgain: 'Jaribu tena',
    grantAccess: 'Idhinisha ufikiaji',
    continueButton: 'Endelea',
    // Media test dialog
    quickSetupCheck: 'Uchunguzi wa haraka wa usanidi',
    testYour: 'Jaribu',
    cameraAndMicrophone: 'kamera na kipaza sauti chako',
    skip: 'Ruka',
    preview: 'Hakiki',
    ensureWorkingProperly: 'ili kuhakikisha kila kitu kinafanya kazi vizuri.',
    linkCopied: 'Kiungo kimekopwa!',
    copyThisLink: 'Nakili kiungo hiki',
    openInYourBrowser: 'na kifungue kwenye kivinjari chako.',
    showQuestion: 'Onyesha swali',
    question: 'Swali',
    mediaWarning: 'Ujumbe huu una faili za media',
    showMore: 'Onyesha zaidi',
    showLess: 'Onyesha kidogo',
    // Key error messages
    cameraAccessError: 'Tafadhali ruhusu ufikiaji wa kamera na kipaza sauti ili kurekodi video.',
    browserMediaSupport:
      'Kwa bahati mbaya, kivinjari chako hakitumii uandishi wa vyombo vya habari.',
    enableMicrophoneAccess:
      'Washa ufikiaji wa kipaza sauti katika mipangilio ya kivinjari ili kutuma ujumbe wa sauti.',
  },
  sv: {
    typeMessage: 'Skriv meddelande',
    cancel: 'Avbryt',
    tapToSend: 'Tryck för att skicka',
    tapToStopRecording: 'Tryck för att stoppa inspelning',
    // Video recording modal
    pause: 'Pausa',
    pausing: 'Pausar...',
    stop: 'Stoppa',
    stopping: 'Stoppar...',
    continue: 'Fortsätt',
    resuming: 'Återupptar...',
    switchCamera: 'Växla kamera',
    switching: 'Växlar...',
    record: 'Spela in',
    starting: 'Startar...',
    send: 'Skicka',
    sending: 'Skickar...',
    canceling: 'Avbryter...',
    // Permission dialog
    mediaAccess: 'Medieåtkomst',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Beviljad',
    required: 'Krävs',
    skipForNow: 'Hoppa över nu',
    tryAgain: 'Försök igen',
    grantAccess: 'Bevilja åtkomst',
    continueButton: 'Fortsätt',
    // Media test dialog
    quickSetupCheck: 'Snabb installationskontroll',
    testYour: 'Testa din',
    cameraAndMicrophone: 'kamera och mikrofon',
    skip: 'Hoppa över',
    preview: 'Förhandsvisning',
    ensureWorkingProperly: 'för att säkerställa att allt fungerar korrekt.',
    linkCopied: 'Länk kopierad!',
    copyThisLink: 'Kopiera denna länk',
    openInYourBrowser: 'och öppna den i din webbläsare.',
    showQuestion: 'Visa fråga',
    question: 'Fråga',
    mediaWarning: 'Detta meddelande innehåller mediefiler',
    showMore: 'Visa mer',
    showLess: 'Visa mindre',
    // Key error messages
    cameraAccessError: 'Tillåt åtkomst till kamera och mikrofon för att spela in video.',
    browserMediaSupport: 'Tyvärr stöder inte din webbläsare mediainspelning.',
    enableMicrophoneAccess:
      'Aktivera mikrofonåtkomst i webbläsarens inställningar för att skicka ljudmeddelanden.',
  },
  ta: {
    typeMessage: 'செய்தி தட்டச்சு செய்யவும்',
    cancel: 'ரத்து',
    tapToSend: 'அனுப்ப தட்டவும்',
    tapToStopRecording: 'பதிவை நிறுத்த தட்டவும்',
    // Video recording modal
    pause: 'இடைநிறுத்தம்',
    pausing: 'இடைநிறுத்தம் செய்யப்படுகிறது...',
    stop: 'நிறுத்து',
    stopping: 'நிறுத்தப்படுகிறது...',
    continue: 'தொடரவும்',
    resuming: 'மீண்டும் தொடங்கப்படுகிறது...',
    switchCamera: 'கேமராவை மாற்றவும்',
    switching: 'மாற்றப்படுகிறது...',
    record: 'பதிவு செய்',
    starting: 'தொடங்கப்படுகிறது...',
    send: 'அனுப்பு',
    sending: 'அனுப்பப்படுகிறது...',
    canceling: 'ரத்து செய்யப்படுகிறது...',
    // Permission dialog
    mediaAccess: 'ஊடக அணுகல்',
    camera: 'கேமரா',
    microphone: 'ஒலிவாங்கி',
    granted: 'அனுமதிக்கப்பட்டது',
    required: 'தேவை',
    skipForNow: 'இப்போது தவிர்க்கவும்',
    tryAgain: 'மீண்டும் முயற்சிக்கவும்',
    grantAccess: 'அணுகல் அளிக்கவும்',
    continueButton: 'தொடரவும்',
    // Media test dialog
    quickSetupCheck: 'விரைவான அமைப்பு சோதனை',
    testYour: 'உங்கள்',
    cameraAndMicrophone: 'கேமரா மற்றும் மைக்ரோஃபோனை சோதனை செய்யவும்',
    skip: 'தவிர்க்கவும்',
    preview: 'முன்னோட்டம்',
    ensureWorkingProperly: 'எல்லாம் சரியாக செயல்படுவதை உறுதிப்படுத்தவும்.',
    linkCopied: 'இணைப்பு நகலெடுக்கப்பட்டது!',
    copyThisLink: 'இந்த இணைப்பை நகலெடுக்கவும்',
    openInYourBrowser: 'உங்கள் உலாவியில் திறக்கவும்.',
    showQuestion: 'கேள்வியை காட்டு',
    question: 'கேள்வி',
    mediaWarning: 'இந்த செய்தியில் ஊடக கோப்புகள் உள்ளன',
    showMore: 'மேலும் காட்டு',
    showLess: 'குறைவாக காட்டு',
    // Key error messages
    cameraAccessError:
      'வீடியோ பதிவு செய்ய தயவுசெய்து கேமரா மற்றும் மைக்ரோஃபோன் அணுகலை அனுமதிக்கவும்.',
    browserMediaSupport: 'துரதிர்ஷ்டவசமாக, உங்கள் உலாவி மீடியா பதிவை ஆதரிக்கவில்லை.',
    enableMicrophoneAccess:
      'ஆடியோ செய்திகளை அனுப்ப உலாவி அமைப்புகளில் மைக்ரோஃபோன் அணுகலை இயக்கவும்.',
  },
  te: {
    typeMessage: 'సందేశం టైప్ చేయండి',
    cancel: 'రద్దు',
    tapToSend: 'పంపడానికి నొక్కండి',
    tapToStopRecording: 'రికార్డింగ్ ఆపడానికి నొక్కండి',
    // Video recording modal
    pause: 'విరామం',
    pausing: 'విరామం చేయబడుతోంది...',
    stop: 'ఆపండి',
    stopping: 'ఆపబడుతోంది...',
    continue: 'కొనసాగించండి',
    resuming: 'మళ్లీ ప్రారంభమవుతోంది...',
    switchCamera: 'కెమెరాను మార్చండి',
    switching: 'మార్చబడుతోంది...',
    record: 'రికార్డ్ చేయండి',
    starting: 'ప్రారంభమవుతోంది...',
    send: 'పంపండి',
    sending: 'పంపబడుతోంది...',
    canceling: 'రద్దు చేయబడుతోంది...',
    // Permission dialog
    mediaAccess: 'మీడియా యాక్సెస్',
    camera: 'కెమెరా',
    microphone: 'మైక్రోఫోన్',
    granted: 'అనుమతించబడింది',
    required: 'అవసరం',
    skipForNow: 'ఇప్పుడు దాటవేయండి',
    tryAgain: 'మళ్లీ ప్రయత్నించండి',
    grantAccess: 'యాక్సెస్ ఇవ్వండి',
    continueButton: 'కొనసాగించండి',
    // Media test dialog
    quickSetupCheck: 'త్వరిత సెటప్ పరీక్ష',
    testYour: 'మీ',
    cameraAndMicrophone: 'కెమెరా మరియు మైక్రోఫోన్ను పరీక్షించండి',
    skip: 'దాటవేయండి',
    preview: 'పూర్వదర్శనం',
    ensureWorkingProperly: 'అన్నీ సరిగ్గా పనిచేస్తున్నాయో లేదో నిర్ధారించుకోండి.',
    linkCopied: 'లింక్ కాపీ చేయబడింది!',
    copyThisLink: 'ఈ లింక్‌ను కాపీ చేయండి',
    openInYourBrowser: 'మరియు మీ బ్రౌజర్‌లో తెరవండి.',
    showQuestion: 'ప్రశ్నను చూపించు',
    question: 'ప్రశ్న',
    mediaWarning: 'ఈ సందేశంలో మీడియా ఫైళ్లు ఉన్నాయి',
    showMore: 'మరింత చూపించు',
    showLess: 'తక్కువ చూపించు',
    // Key error messages
    cameraAccessError:
      'వీడియో రికార్డ్ చేయడానికి దయచేసి కెమెరా మరియు మైక్రోఫోన్ ప్రవేశాన్ని అనుమతించండి.',
    browserMediaSupport: 'దురదృష్టవశాత్తు, మీ బ్రౌజర్ మీడియా రికార్డింగ్ను సపోర్ట్ చేయదు.',
    enableMicrophoneAccess:
      'ఆడియో సందేశాలను పంపడానికి మీ బ్రౌజర్ సెట్టింగ్స్‌లో మైక్రోఫోన్ ప్రవేశాన్ని ఇనేబుల్ చేయండి.',
  },
  th: {
    typeMessage: 'พิมพ์ข้อความ',
    cancel: 'ยกเลิก',
    tapToSend: 'แตะเพื่อส่ง',
    tapToStopRecording: 'แตะเพื่อหยุดการบันทึก',
    // Video recording modal
    pause: 'หยุดชั่วคราว',
    pausing: 'กำลังหยุดชั่วคราว...',
    stop: 'หยุด',
    stopping: 'กำลังหยุด...',
    continue: 'ดำเนินการต่อ',
    resuming: 'กำลังดำเนินการต่อ...',
    switchCamera: 'เปลี่ยนกล้อง',
    switching: 'กำลังเปลี่ยน...',
    record: 'บันทึก',
    starting: 'กำลังเริ่มต้น...',
    send: 'ส่ง',
    sending: 'กำลังส่ง...',
    canceling: 'กำลังยกเลิก...',
    // Permission dialog
    mediaAccess: 'การเข้าถึงสื่อ',
    camera: 'กล้อง',
    microphone: 'ไมโครโฟน',
    granted: 'อนุญาต',
    required: 'จำเป็น',
    skipForNow: 'ข้ามไปก่อน',
    tryAgain: 'ลองใหม่',
    grantAccess: 'ให้สิทธิ์เข้าถึง',
    continueButton: 'ดำเนินการต่อ',
    // Media test dialog
    quickSetupCheck: 'ตรวจสอบการตั้งค่าอย่างรวดเร็ว',
    testYour: 'ทดสอบ',
    cameraAndMicrophone: 'กล้องและไมโครโฟนของคุณ',
    skip: 'ข้าม',
    preview: 'ดูตัวอย่าง',
    ensureWorkingProperly: 'เพื่อให้แน่ใจว่าทุกอย่างทำงานได้อย่างถูกต้อง',
    linkCopied: 'ลิงก์ถูกคัดลอกแล้ว!',
    copyThisLink: 'คัดลอกลิงก์นี้',
    openInYourBrowser: 'และเปิดในเบราว์เซอร์ของคุณ',
    showQuestion: 'แสดงคำถาม',
    question: 'คำถาม',
    mediaWarning: 'ข้อความนี้มีไฟล์สื่อ',
    showMore: 'แสดงเพิ่มเติม',
    showLess: 'แสดงน้อยลง',
    // Key error messages
    cameraAccessError: 'โปรดอนุญาตให้เข้าถึงกล้องและไมโครโฟนเพื่อบันทึกวิดีโอ',
    browserMediaSupport: 'ขออภัย เบราว์เซอร์ของคุณไม่รองรับการบันทึกสื่อ',
    enableMicrophoneAccess:
      'เปิดใช้งานการเข้าถึงไมโครโฟนในการตั้งค่าเบราว์เซอร์เพื่อส่งข้อความเสียง',
  },
  tl: {
    typeMessage: 'I-type ang mensahe',
    cancel: 'Kanselahin',
    tapToSend: 'Tapikin upang magpadala',
    tapToStopRecording: 'Tapikin upang itigil ang pag-record',
    // Video recording modal
    pause: 'Pahinga',
    pausing: 'Pinapahinto...',
    stop: 'Itigil',
    stopping: 'Pinipigilan...',
    continue: 'Magpatuloy',
    resuming: 'Nagpapatuloy...',
    switchCamera: 'Palitan ang kamera',
    switching: 'Pinapalitan...',
    record: 'I-record',
    starting: 'Nagsisimula...',
    send: 'Ipadala',
    sending: 'Ipinapadala...',
    canceling: 'Kinakansela...',
    // Permission dialog
    mediaAccess: 'Access sa Media',
    camera: 'Kamera',
    microphone: 'Mikropono',
    granted: 'Ipinagkaloob',
    required: 'Kinakailangan',
    skipForNow: 'Laktawan muna',
    tryAgain: 'Subukan muli',
    grantAccess: 'Bigyan ng access',
    continueButton: 'Magpatuloy',
    // Media test dialog
    quickSetupCheck: 'Mabilis na Pagsusuri ng Setup',
    testYour: 'Subukan ang iyong',
    cameraAndMicrophone: 'kamera at mikropono',
    skip: 'Laktawan',
    preview: 'Preview',
    ensureWorkingProperly: 'upang matiyak na maayos ang lahat.',
    linkCopied: 'Kopya ng link!',
    copyThisLink: 'Kopyahin ang link na ito',
    openInYourBrowser: 'at buksan ito sa iyong browser.',
    showQuestion: 'Ipakita ang tanong',
    question: 'Tanong',
    mediaWarning: 'Ang mensaheng ito ay naglalaman ng mga file ng media',
    showMore: 'Ipakita ang higit pa',
    showLess: 'Ipakita ang mas kaunti',
    // Key error messages
    cameraAccessError:
      'Mangyaring payagan ang access sa kamera at mikropono para mag-record ng video.',
    browserMediaSupport:
      'Sa kasamaang palad, hindi sinusuportahan ng iyong browser ang media recording.',
    enableMicrophoneAccess:
      'I-enable ang access sa mikropono sa mga setting ng browser para magpadala ng mga audio message.',
  },
  tr: {
    typeMessage: 'Mesaj yazın',
    cancel: 'İptal',
    tapToSend: 'Göndermek için dokunun',
    tapToStopRecording: 'Kaydı durdurmak için dokunun',
    // Video recording modal
    pause: 'Duraklat',
    pausing: 'Duraklatılıyor...',
    stop: 'Durdur',
    stopping: 'Durduruluyor...',
    continue: 'Devam et',
    resuming: 'Devam ediliyor...',
    switchCamera: 'Kamera değiştir',
    switching: 'Değiştiriliyor...',
    record: 'Kaydet',
    starting: 'Başlatılıyor...',
    send: 'Gönder',
    sending: 'Gönderiliyor...',
    canceling: 'İptal ediliyor...',
    // Permission dialog
    mediaAccess: 'Medya Erişimi',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Verildi',
    required: 'Gerekli',
    skipForNow: 'Şimdilik geç',
    tryAgain: 'Tekrar dene',
    grantAccess: 'Erişim ver',
    continueButton: 'Devam et',
    // Media test dialog
    quickSetupCheck: 'Hızlı kurulum kontrolü',
    testYour: 'Test edin',
    cameraAndMicrophone: 'kamera ve mikrofonunuzu',
    skip: 'Geç',
    preview: 'Önizleme',
    ensureWorkingProperly: 'her şeyin düzgün çalıştığından emin olmak için.',
    linkCopied: 'Bağlantı kopyalandı!',
    copyThisLink: 'Bu bağlantıyı kopyalayın',
    openInYourBrowser: 've tarayıcınızda açın.',
    showQuestion: 'Soruyu göster',
    question: 'Soru',
    mediaWarning: 'Bu mesaj medya dosyaları içeriyor',
    showMore: 'Daha fazla göster',
    showLess: 'Daha az göster',
    // Key error messages
    cameraAccessError: 'Video kaydetmek için lütfen kamera ve mikrofon erişimine izin verin.',
    browserMediaSupport: 'Maalesef tarayıcınız medya kaydını desteklemiyor.',
    enableMicrophoneAccess:
      'Sesli mesaj göndermek için tarayıcı ayarlarında mikrofon erişimini etkinleştirin.',
  },
  uk: {
    typeMessage: 'Введіть повідомлення',
    cancel: 'Скасувати',
    tapToSend: 'Натисніть, щоб надіслати',
    tapToStopRecording: 'Натисніть, щоб зупинити запис',
    // Video recording modal
    pause: 'Пауза',
    pausing: 'Призупинення...',
    stop: 'Стоп',
    stopping: 'Зупинка...',
    continue: 'Продовжити',
    resuming: 'Відновлення...',
    switchCamera: 'Перемкнути камеру',
    switching: 'Перемикання...',
    record: 'Записати',
    starting: 'Запуск...',
    send: 'Надіслати',
    sending: 'Надсилання...',
    canceling: 'Скасування...',
    // Permission dialog
    mediaAccess: 'Доступ до медіа',
    camera: 'Камера',
    microphone: 'Мікрофон',
    granted: 'Надано',
    required: 'Потрібно',
    skipForNow: 'Пропустити зараз',
    tryAgain: 'Спробувати знову',
    grantAccess: 'Надати доступ',
    continueButton: 'Продовжити',
    // Media test dialog
    quickSetupCheck: 'Швидка перевірка налаштувань',
    testYour: 'Протестуйте вашу',
    cameraAndMicrophone: 'камеру та мікрофон',
    skip: 'Пропустити',
    preview: 'Попередній перегляд',
    ensureWorkingProperly: 'щоб переконатися, що все працює правильно.',
    linkCopied: 'Посилання скопійовано!',
    copyThisLink: 'Скопіюйте це посилання',
    openInYourBrowser: 'і відкрийте його у вашому браузері.',
    showQuestion: 'Показати питання',
    question: 'Питання',
    mediaWarning: 'Це повідомлення містить медіафайли',
    showMore: 'Показати більше',
    showLess: 'Показати менше',
    // Key error messages
    cameraAccessError: 'Будь ласка, дозвольте доступ до камери та мікрофона для запису відео.',
    browserMediaSupport: 'На жаль, ваш браузер не підтримує запис медіа.',
    enableMicrophoneAccess:
      'Увімкніть доступ до мікрофона в налаштуваннях браузера для надсилання аудіоповідомлень.',
  },
  ur: {
    typeMessage: 'پیغام ٹائپ کریں',
    cancel: 'منسوخ',
    tapToSend: 'بھیجنے کے لیے ٹیپ کریں',
    tapToStopRecording: 'ریکارڈنگ بند کرنے کے لیے ٹیپ کریں',
    // Video recording modal
    pause: 'رکیں',
    pausing: 'رکا جا رہا ہے...',
    stop: 'بند کریں',
    stopping: 'بند کیا جا رہا ہے...',
    continue: 'جاری رکھیں',
    resuming: 'دوبارہ شروع کیا جا رہا ہے...',
    switchCamera: 'کیمرا تبدیل کریں',
    switching: 'تبدیل کیا جا رہا ہے...',
    record: 'ریکارڈ کریں',
    starting: 'شروع کیا جا رہا ہے...',
    send: 'بھیجیں',
    sending: 'بھیجا جا رہا ہے...',
    canceling: 'منسوخ کیا جا رہا ہے...',
    // Permission dialog
    mediaAccess: 'میڈیا رسائی',
    camera: 'کیمرا',
    microphone: 'مائیکروفون',
    granted: 'اجازت دی گئی',
    required: 'ضروری',
    skipForNow: 'ابھی چھوڑیں',
    tryAgain: 'دوبارہ کوشش کریں',
    grantAccess: 'رسائی دیں',
    continueButton: 'جاری رکھیں',
    // Media test dialog
    quickSetupCheck: 'فوری سیٹ اپ کی جانچ',
    testYour: 'اپنے',
    cameraAndMicrophone: 'کیمرے اور مائیکروفون کو ٹیسٹ کریں',
    skip: 'چھوڑیں',
    preview: 'پیش منظر',
    ensureWorkingProperly: 'تاکہ یہ یقینی بنایا جا سکے کہ سب کچھ صحیح طریقے سے کام کر رہا ہے۔',
    linkCopied: 'لنک کاپی ہو گیا!',
    copyThisLink: 'اس لنک کو کاپی کریں',
    openInYourBrowser: 'اور اپنے براؤزر میں کھولیں۔',
    showQuestion: 'سوال دکھائیں',
    question: 'سوال',
    mediaWarning: 'اس پیغام میں میڈیا فائلیں شامل ہیں',
    showMore: 'مزید دکھائیں',
    showLess: 'کم دکھائیں',
    // Key error messages
    cameraAccessError:
      'ویڈیو ریکارڈ کرنے کے لیے براہ کرم کیمرے اور مائیکروفون تک رسائی کی اجازت دیں۔',
    browserMediaSupport: 'بدقسمتی سے، آپ کا براؤزر میڈیا ریکارڈنگ کی حمایت نہیں کرتا۔',
    enableMicrophoneAccess:
      'آڈیو پیغامات بھیجنے کے لیے اپنے براؤزر کی ترتیبات میں مائیکروفون تک رسائی کو فعال کریں۔',
  },
  vi: {
    typeMessage: 'Nhập tin nhắn',
    cancel: 'Hủy',
    tapToSend: 'Nhấn để gửi',
    tapToStopRecording: 'Nhấn để dừng ghi âm',
    // Video recording modal
    pause: 'Tạm dừng',
    pausing: 'Đang tạm dừng...',
    stop: 'Dừng',
    stopping: 'Đang dừng...',
    continue: 'Tiếp tục',
    resuming: 'Đang tiếp tục...',
    switchCamera: 'Chuyển camera',
    switching: 'Đang chuyển...',
    record: 'Ghi hình',
    starting: 'Đang bắt đầu...',
    send: 'Gửi',
    sending: 'Đang gửi...',
    canceling: 'Đang hủy...',
    // Permission dialog
    mediaAccess: 'Quyền truy cập phương tiện',
    camera: 'Camera',
    microphone: 'Microphone',
    granted: 'Đã cấp',
    required: 'Cần thiết',
    skipForNow: 'Bỏ qua bây giờ',
    tryAgain: 'Thử lại',
    grantAccess: 'Cấp quyền truy cập',
    continueButton: 'Tiếp tục',
    // Media test dialog
    quickSetupCheck: 'Kiểm tra cài đặt nhanh',
    testYour: 'Kiểm tra',
    cameraAndMicrophone: 'camera và microphone của bạn',
    skip: 'Bỏ qua',
    preview: 'Xem trước',
    ensureWorkingProperly: 'để đảm bảo mọi thứ hoạt động đúng cách.',
    linkCopied: 'Liên kết đã được sao chép!',
    copyThisLink: 'Sao chép liên kết này',
    openInYourBrowser: 'và mở nó trong trình duyệt của bạn.',
    showQuestion: 'Hiển thị câu hỏi',
    question: 'Câu hỏi',
    mediaWarning: 'Tin nhắn này chứa tệp phương tiện',
    showMore: 'Hiển thị thêm',
    showLess: 'Hiển thị ít hơn',
    // Key error messages
    cameraAccessError: 'Vui lòng cho phép truy cập camera và microphone để quay video.',
    browserMediaSupport: 'Rất tiếc, trình duyệt của bạn không hỗ trợ ghi phương tiện.',
    enableMicrophoneAccess:
      'Bật quyền truy cập microphone trong cài đặt trình duyệt để gửi tin nhắn âm thanh.',
  },
  cy: {
    typeMessage: 'Teipiwch neges',
    cancel: 'Canslo',
    tapToSend: 'Tapiwch i anfon',
    tapToStopRecording: 'Tapiwch i stopio recordio',
    // Video recording modal
    pause: 'Oedi',
    pausing: 'Yn oedi...',
    stop: 'Stopio',
    stopping: 'Yn stopio...',
    continue: 'Parhau',
    resuming: 'Yn ailgychwyn...',
    switchCamera: 'Newid camera',
    switching: 'Yn newid...',
    record: 'Recordio',
    starting: 'Yn dechrau...',
    send: 'Anfon',
    sending: 'Yn anfon...',
    canceling: 'Yn canslo...',
    // Permission dialog
    mediaAccess: 'Mynediad i Gyfryngau',
    camera: 'Camera',
    microphone: 'Meicroffon',
    granted: 'Wedi caniatáu',
    required: 'Yn ofynnol',
    skipForNow: 'Neidio am nawr',
    tryAgain: 'Ceisiwch eto',
    grantAccess: 'Caniatáu mynediad',
    continueButton: 'Parhau',
    // Media test dialog
    quickSetupCheck: 'Gwiriad gosod cyflym',
    testYour: 'Profwch eich',
    cameraAndMicrophone: 'camera a meicroffon',
    skip: 'Hepgor',
    preview: 'Rhagolwg',
    ensureWorkingProperly: "i sicrhau bod popeth yn gweithio'n iawn.",
    linkCopied: 'Cysylltiad wedi ei gopïo!',
    copyThisLink: 'Copïwch y ddolen hon',
    openInYourBrowser: 'a’i hagor yn eich porwr.',
    showQuestion: 'Dangos cwestiwn',
    question: 'Cwestiwn',
    mediaWarning: 'Mae’r neges hon yn cynnwys ffeiliau cyfryngau',
    showMore: 'Dangos mwy',
    showLess: 'Dangos llai',
    // Key error messages
    cameraAccessError: "Caniatâwch fynediad i'r camera a'r meicroffon i recordio fideo.",
    browserMediaSupport: 'Yn anffodus, nid yw eich porwr yn cefnogi recordio cyfryngau.',
    enableMicrophoneAccess:
      "Galluogwch fynediad i'r meicroffon yng ngosodiadau eich porwr i anfon negeseuon sain.",
  },
  zu: {
    typeMessage: 'Thayipha umyalezo',
    cancel: 'Khansela',
    tapToSend: 'Thepha ukuthumela',
    tapToStopRecording: 'Thepha ukumisa ukurekhoda',
    // Video recording modal
    pause: 'Misa',
    pausing: 'Kuyamiswa...',
    stop: 'Yeka',
    stopping: 'Kuyekelwa...',
    continue: 'Qhubeka',
    resuming: 'Kuyaqhubeka...',
    switchCamera: 'Shintshanisa ikhamera',
    switching: 'Kuyashintshwa...',
    record: 'Rekhoda',
    starting: 'Kuyaqala...',
    send: 'Thumela',
    sending: 'Kuyathunyelwa...',
    canceling: 'Kuyakhanselwa...',
    // Permission dialog
    mediaAccess: 'Ukufinyelela Imidiya',
    camera: 'Ikhamera',
    microphone: 'Umakrofoni',
    granted: 'Kunikeziwe',
    required: 'Kuyadingeka',
    skipForNow: 'Yeqa okwamanje',
    tryAgain: 'Zama futhi',
    grantAccess: 'Nikeza ukufinyelela',
    continueButton: 'Qhubeka',
    // Media test dialog
    quickSetupCheck: 'Ukuhlola ukusethwa okusheshayo',
    testYour: 'Hlola',
    cameraAndMicrophone: 'ikhamera nemayikrofoni yakho',
    skip: 'Yeqa',
    preview: 'Buka kuqala',
    ensureWorkingProperly: 'ukuqinisekisa ukuthi konke kusebenza kahle.',
    linkCopied: 'Isixhumanisi sikhophiwe!',
    copyThisLink: 'Kopisha lesi sixhumanisi',
    openInYourBrowser: 'futhi uvule ku-browser yakho.',
    showQuestion: 'Khombisa umbuzo',
    question: 'Umbuzo',
    mediaWarning: 'Lo myalezo uqukethe amafayela emidiya',
    showMore: 'Khombisa okuningi',
    showLess: 'Khombisa okuncane',
    // Key error messages
    cameraAccessError:
      'Sicela uvumele ukufinyelela kwikhamera nemayikrofoni ukuze urekhode ividiyo.',
    browserMediaSupport: 'Ngeshwa, isiphequluli sakho asikweseki ukurekhoda imidiya.',
    enableMicrophoneAccess:
      'Vumela ukufinyelela kumayikrofoni kumasethingi esiphequluli sakho ukuze uthumele imilayezo yomsindo.',
  },
  bn: {
    typeMessage: 'বার্তা টাইপ করুন',
    cancel: 'বাতিল',
    tapToSend: 'পাঠাতে ট্যাপ করুন',
    tapToStopRecording: 'রেকর্ডিং বন্ধ করতে ট্যাপ করুন',
    // Video recording modal
    pause: 'বিরতি',
    pausing: 'বিরতি দেওয়া হচ্ছে...',
    stop: 'থামুন',
    stopping: 'থামানো হচ্ছে...',
    continue: 'চালিয়ে যান',
    resuming: 'পুনরায় শুরু হচ্ছে...',
    switchCamera: 'ক্যামেরা পরিবর্তন করুন',
    switching: 'পরিবর্তন হচ্ছে...',
    record: 'রেকর্ড',
    starting: 'শুরু হচ্ছে...',
    send: 'পাঠান',
    sending: 'পাঠানো হচ্ছে...',
    canceling: 'বাতিল করা হচ্ছে...',
    // Permission dialog
    mediaAccess: 'মিডিয়া অ্যাক্সেস',
    camera: 'ক্যামেরা',
    microphone: 'মাইক্রোফোন',
    granted: 'অনুমতি দেওয়া হয়েছে',
    required: 'প্রয়োজনীয়',
    skipForNow: 'আপাতত এড়িয়ে যান',
    tryAgain: 'আবার চেষ্টা করুন',
    grantAccess: 'অ্যাক্সেস দিন',
    continueButton: 'চালিয়ে যান',
    // Media test dialog
    quickSetupCheck: 'দ্রুত সেটআপ চেক',
    testYour: 'আপনার',
    cameraAndMicrophone: 'ক্যামেরা এবং মাইক্রোফোন পরীক্ষা করুন',
    skip: 'এড়িয়ে যান',
    preview: 'পূর্বরূপ',
    ensureWorkingProperly: 'সবকিছু ঠিকমতো কাজ করছে তা নিশ্চিত করতে।',
    linkCopied: 'লিঙ্ক কপি হয়েছে!',
    copyThisLink: 'এই লিঙ্কটি কপি করুন',
    openInYourBrowser: 'এবং আপনার ব্রাউজারে খুলুন।',
    showQuestion: 'প্রশ্ন দেখান',
    question: 'প্রশ্ন',
    mediaWarning: 'এই বার্তায় মিডিয়া ফাইল রয়েছে',
    showMore: 'আরও দেখান',
    showLess: 'কম দেখান',
    // Key error messages
    cameraAccessError:
      'ভিডিও রেকর্ড করতে অনুগ্রহ করে ক্যামেরা এবং মাইক্রোফোন অ্যাক্সেস অনুমতি দিন।',
    browserMediaSupport: 'দুর্ভাগ্যবশত, আপনার ব্রাউজার মিডিয়া রেকর্ডিং সমর্থন করে না।',
    enableMicrophoneAccess:
      'অডিও বার্তা পাঠাতে আপনার ব্রাউজার সেটিংসে মাইক্রোফোন অ্যাক্সেস সক্ষম করুন।',
  },
  uz: {
    typeMessage: 'Xabar yozing',
    cancel: 'Bekor qilish',
    tapToSend: "Jo'natish uchun bosing",
    tapToStopRecording: "Yozishni to'xtatish uchun bosing",
    // Video recording modal
    pause: "To'xtatib turish",
    pausing: "To'xtatilmoqda...",
    stop: "To'xtatish",
    stopping: "To'xtatilmoqda...",
    continue: 'Davom etish',
    resuming: 'Davom ettirilmoqda...',
    switchCamera: "Kamerani o'zgartirish",
    switching: "O'zgartirilmoqda...",
    record: 'Yozish',
    starting: 'Boshlanmoqda...',
    send: "Jo'natish",
    sending: "Jo'natilmoqda...",
    canceling: 'Bekor qilinmoqda...',
    // Permission dialog
    mediaAccess: 'Media kirish',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    granted: 'Ruxsat berilgan',
    required: 'Talab qilinadi',
    skipForNow: "Hozircha o'tkazib yuborish",
    tryAgain: 'Qayta urinish',
    grantAccess: 'Ruxsat berish',
    continueButton: 'Davom etish',
    // Media test dialog
    quickSetupCheck: 'Tezkor sozlash tekshiruvi',
    testYour: 'Sizning',
    cameraAndMicrophone: "kamera va mikrofoningizni sinab ko'ring",
    skip: "O'tkazib yuborish",
    preview: "Ko'rib chiqish",
    ensureWorkingProperly: "hamma narsa to'g'ri ishlayotganiga ishonch hosil qilish uchun.",
    linkCopied: 'Havola nusxalandi!',
    copyThisLink: 'Bu havolani nusxalang',
    openInYourBrowser: 'va brauzeringizda oching.',
    showQuestion: "Savolni ko'rsatish",
    question: 'Savol',
    mediaWarning: 'Bu xabarda media fayllari mavjud',
    showMore: "Ko'proq ko'rsatish",
    showLess: "Kamroq ko'rsatish",
    // Key error messages
    cameraAccessError: 'Video yozish uchun kamera va mikrofonga ruxsat bering.',
    browserMediaSupport: "Afsuski, brauzeringiz media yozishni qo'llab-quvvatlamaydi.",
    enableMicrophoneAccess:
      "Audio xabarlar jo'natish uchun brauzer sozlamalarida mikrofonga kirishni yoqing.",
  },
};

// Export individual objects for backward compatibility
export const translateTypeMessage: { [key: string]: string } = Object.fromEntries(
  Object.entries(translations).map(([lang, trans]) => [lang, trans.typeMessage]),
);

export const translateCancel: { [key: string]: string } = Object.fromEntries(
  Object.entries(translations).map(([lang, trans]) => [lang, trans.cancel]),
);

export const translateTapToSend: { [key: string]: string } = Object.fromEntries(
  Object.entries(translations).map(([lang, trans]) => [lang, trans.tapToSend]),
);

export const translateTapToStopRecording: { [key: string]: string } = Object.fromEntries(
  Object.entries(translations).map(([lang, trans]) => [lang, trans.tapToStopRecording]),
);
